// // import React from "react";
// // // import CTABanner from "../components/Home/CTABanner";
// // import {
// //   FaRocket,
// //   FaUsers,
// //   FaLightbulb,
// //   FaCheckCircle,
// //   FaShieldAlt,
// //   FaMobileAlt,
// //   FaClock,
// // } from "react-icons/fa";
// // import { GiReceiveMoney, GiArchiveResearch } from "react-icons/gi";
// // import { motion } from "framer-motion";

// // const cardVariants = {
// //   hiddenLeft: { opacity: 0, x: -100 },
// //   hiddenRight: { opacity: 0, x: 100 },
// //   visible: { opacity: 1, x: 0, transition: { duration: 0.7 } },
// // };
// // const About = () => {
// //   return (
// //     <div className="bg-[#050A18] text-[#1D3557]">
// //       <header className="relative text-center text-white mb-10 py-28 px-4 overflow-hidden">
// //         <div className="absolute inset-0 bg-cover bg-[url('/images/about/about-banner.jpg')] bg-center"></div>
// //         <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/60 to-black/60"></div>

// //         <div className="relative z-10 max-w-4xl mx-auto">
// //           <h1 className="text-5xl md:text-6xl font-extrabold mb-4 text-[white]">
// //             About <span className="text-[#4FA0FF]">Salarymates</span>
// //           </h1>
// //           <p className="text-xl opacity-90 leading-relaxed max-w-2xl mx-auto">
// //             Revolutionizing financial solutions for salaried individuals with
// //             speed, transparency, and trust
// //           </p>
// //         </div>
// //       </header>

// //       {/* Main Content */}
// //       <div className="max-w-6xl mx-auto px-5">
// //         {/* Our Journey & Team Section */}
// //         <section className="relative py-10 border-gray-700">
// //           <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-40 h-40"></div>

// //           <div className="relative bg-[#111827]/70 rounded-2xl p-8 pt-2 md:p-10 shadow-lg  z-10">
// //             <div className="text-center mb-5">
// //               {/* <h2 className="text-3xl font-bold text-[#1D3557] text-center mb-6 relative inline-block mx-a">
// //                 <span className="absolute -bottom-2 left-0 w-full h-2 bg-[#FFD700] opacity-60"></span>
// //                 Our Journey & Team
// //               </h2> */}
// //               <h4 className="text-xl md:text-6xl font-extrabold mb-4 text-center relative inline-block text-[white]">
// //                 Connect with{" "}
// //                 <span className=" absolute -bottom-2 left-0 w-full h-2 text-[#4FA0FF]">
// //                   Salarymates
// //                 </span>
// //               </h4>

// //               <p className="text-gray-500 text-center text-lg  pt-10 mt-10 leading-relaxed max-w-3xl mx-auto mb-10">
// //                 At Salarymates, we're driven by the mission to empower
// //                 salaried individuals with financial freedom. Our dedicated team
// //                 and streamlined process ensure you're supported every step of
// //                 the way.
// //               </p>
// //             </div>

// //             <div className="flex justify-center gap-8 flex-wrap mt-12">
// //               {[
// //                 {
// //                   icon: <FaRocket className="text-2xl text-white" />,
// //                   title: "Founded in 2020",
// //                   content:
// //                     "Started with a vision to simplify salary-based loans for working professionals",
// //                 },
// //                 {
// //                   icon: <FaUsers className="text-2xl text-white" />,
// //                   title: "50+ Team Members",
// //                   content:
// //                     "Dedicated professionals working to make your financial journey seamless",
// //                 },
// //                 {
// //                   icon: <FaLightbulb className="text-2xl text-white" />,
// //                   title: "1M+ Customers",
// //                   content:
// //                     "Trusted by over a million salaried individuals across India",
// //                 },
// //               ].map((item, index) => (
// //                 <div
// //                   key={index}
// //                   className="flex-1 min-w-[300px] bg-white/10 rounded-xl p-8 shadow-sm  transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
// //                 >
// //                   <div className="w-14 h-14 bg-[#4FA0FF] rounded-xl flex items-center justify-center text-white mb-5">
// //                     {item.icon}
// //                   </div>
// //                   <h3 className="text-xl font-semibold text-[#40A0FF] mb-4">
// //                     {item.title}
// //                   </h3>
// //                   <p className="text-gray-300 leading-relaxed">
// //                     {item.content}
// //                   </p>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>
// //         </section>

// //         {/* === Cards Section === */}
// //         {[
// //           {
// //             title: "Instant Loan Approval",
// //             description:
// //               "Apply and get approved for a loan within minutes. Our automated system ensures that you receive instant decisions based on your profile.",
// //             image: "/images/about/about-1.jpg",
// //             icon: <GiReceiveMoney className="text-[#4FA0FF] text-3xl" />,
// //             reverse: false,
// //             points: [
// //               {
// //                 text: "Approval in as little as 5 minutes",
// //                 icon: <FaClock className="text-[#4FA0FF] mr-3" />,
// //               },
// //               {
// //                 text: "24/7 application processing",
// //                 icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
// //               },
// //               {
// //                 text: "Real-time status updates",
// //                 icon: <FaMobileAlt className="text-[#4FA0FF] mr-3" />,
// //               },
// //             ],
// //           },
// //           {
// //             title: "100% Digital Process",
// //             description:
// //               "Experience a paperless journey from start to finish. Upload your documents, verify your details, and get disbursal—all online.",
// //             image: "/images/about/about-2.jpg",
// //             icon: <GiArchiveResearch className="text-[#4FA0FF] text-3xl" />,
// //             reverse: true,
// //             points: [
// //               {
// //                 text: "No physical paperwork required",
// //                 icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
// //               },
// //               {
// //                 text: "eKYC and digital signatures",
// //                 icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
// //               },
// //               {
// //                 text: "Instant document verification",
// //                 icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
// //               },
// //             ],
// //           },
// //           {
// //             title: "Secure & Trusted",
// //             description:
// //               "Your data is safe with us. We use industry-grade encryption and privacy standards to keep your information secure at all times.",
// //             image: "/images/about/about-3.jpg",
// //             icon: <FaShieldAlt className="text-[#4FA0FF] text-3xl" />,
// //             reverse: false,
// //             points: [
// //               {
// //                 text: "Bank-level security protocols",
// //                 icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
// //               },
// //               {
// //                 text: "Regular security audits",
// //                 icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
// //               },
// //               {
// //                 text: "GDPR compliant data handling",
// //                 icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
// //               },
// //             ],
// //           },
// //         ].map((feature, index) => (
// //           <motion.section
// //             key={index}
// //             initial={feature.reverse ? "hiddenRight" : "hiddenLeft"}
// //             whileInView="visible"
// //             viewport={{ once: true, amount: 0.2 }}
// //             variants={cardVariants}
// //             className={`my-16 rounded-2xl overflow-hidden flex flex-col md:flex-row ${
// //               feature.reverse ? "md:flex-row-reverse" : ""
// //             } shadow-sm border border-gray-700 bg-[#111827]/70 backdrop-blur-md`}
// //           >
// //             <div className="flex-1 min-w-[300px] p-8 md:p-12 flex flex-col justify-center">
// //               <div className="flex items-center mb-5">
// //                 <div className="w-12 h-12 bg-[#1E293B] rounded-lg flex items-center justify-center shadow-md mr-4">
// //                   {feature.icon}
// //                 </div>
// //                 <h2 className="text-2xl font-bold text-white m-0">
// //                   {feature.title}
// //                 </h2>
// //               </div>
// //               <p className="text-gray-300 text-lg leading-relaxed mb-8">
// //                 {feature.description}
// //               </p>
// //               <ul className="list-none p-0 m-0">
// //                 {feature.points.map((point, i) => (
// //                   <li key={i} className="flex items-center mb-3 text-gray-300">
// //                     {point.icon}
// //                     {point.text}
// //                   </li>
// //                 ))}
// //               </ul>
// //             </div>
// //             <div className="flex-1 min-w-[300px] min-h-[400px] relative flex items-center justify-center p-0 overflow-hidden">
// //               <div
// //                 className={`absolute inset-0 ${
// //                   feature.reverse ? "bg-gradient-to-r" : "bg-gradient-to-l"
// //                 } from-[#4FA0FF]/10 to-transparent`}
// //               ></div>
// //               <img
// //                 src={feature.image}
// //                 alt={feature.title}
// //                 className="relative z-10 w-full h-full max-h-[400px] object-cover shadow-lg transition-transform duration-300 group-hover:scale-105"
// //               />
// //             </div>
// //           </motion.section>
// //         ))}

// //         {/* Vision & Mission Section */}
// //         <section className="relative py-10 overflow-hidden">
// //           {/* Decorative background elements */}
// //           <div className="absolute -top-32 -left-32 w-96 h-96 rounded-full bg-[radial-gradient(circle,rgba(29,53,87,0.05)_0%,transparent_70%)]"></div>
// //           <div className="absolute -bottom-40 -right-40 w-96 h-96 rounded-full bg-[radial-gradient(circle,rgba(255,215,0,0.05)_0%,transparent_70%)]"></div>

// //           <div className="max-w-7xl mx-auto px-3 md:px-6">
// //             <div className="text-center mb-16">
// //               <h2 className="text-4xl font-bold text-[white] mb-4 relative inline-block">
// //                 <span className="absolute -bottom-2 left-0 w-full h-2 bg-[#40A0FF] opacity-60"></span>
// //                 Our Core Beliefs
// //               </h2>
// //               <p className="text-lg text-gray-500 max-w-2xl mx-auto">
// //                 The foundation of everything we do at Salarymates
// //               </p>
// //             </div>

// //             <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 relative z-10">
// //               {[
// //                 {
// //                   title: "Our Mission",
// //                   icon: (
// //                     <div className="relative">
// //                       <div className="absolute -inset-4 bg-[#4FA0FF] rounded-full opacity-10"></div>
// //                       <FaRocket className="text-5xl text-[#4FA0FF] transform transition-all duration-500 group-hover:rotate-12" />
// //                     </div>
// //                   ),
// //                   content:
// //                     "Our mission is to simplify and speed up personal financing for salaried professionals by providing quick, secure, and transparent loan services that empower individuals to meet their financial needs without the traditional banking hassles.",
// //                   highlight:
// //                     "Empowering salaried professionals with instant financial solutions",
// //                   gradient: "from-[#4FA0FF] to-[#1D3557]",
// //                   bgPattern: "pattern-dots-sm text-[#4FA0FF]/5",
// //                 },
// //                 {
// //                   title: "Our Vision",
// //                   icon: (
// //                     <div className="relative">
// //                       <div className="absolute -inset-4 bg-[#4FA0FF] rounded-full opacity-10"></div>
// //                       <FaLightbulb className="text-5xl text-[#4FA0FF] transform transition-all duration-500 group-hover:scale-110" />
// //                     </div>
// //                   ),
// //                   content:
// //                     "To become India's most trusted short-term loan platform for the salaried workforce, offering unmatched convenience, reliability, and financial freedom through innovative digital solutions.",
// //                   highlight: "Leading the future of digital lending in India",
// //                   gradient: "from-[#1D3557] to-[#4FA0FF]",
// //                   bgPattern: "pattern-waves-sm text-[#4FA0FF]/5",
// //                 },
// //               ].map((card, index) => (
// //                 <div
// //                   key={index}
// //                   className={`group relative bg-[#111827]/70 rounded-3xl p-5 md:p-10 shadow-xl border border-[#E5E5E5] overflow-hidden transition-all duration-500 hover:shadow-2xl hover:-translate-y-2 ${card.bgPattern}`}
// //                 >
// //                   {/* Gradient top border */}
// //                   <div
// //                     className={`absolute top-0 left-0 w-full h-2 bg-gradient-to-r ${card.gradient}`}
// //                   ></div>

// //                   {/* Floating icon with halo effect */}
// //                   <div className="mt-4 mb-8 flex justify-center">
// //                     {card.icon}
// //                   </div>

// //                   <h3 className="text-3xl font-bold text-[#4FA0FF] mb-6 text-center">
// //                     {card.title}
// //                   </h3>

// //                   <p className="text-gray-400 text-lg leading-relaxed mb-8 text-center">
// //                     {card.content}
// //                   </p>

// //                   <div className="mt-8 p-6 bg-gradient-to-r from-[#4FA0FF]/5 to-[#1D3557]/5 rounded-xl border-l-4 border-[#4FA0FF] transition-all duration-500 group-hover:bg-gradient-to-r group-hover:from-[#4FA0FF]/10 group-hover:to-[#1D3557]/10">
// //                     <p className="text-[white]/70 font-bold m-0 italic text-lg text-center">
// //                       "{card.highlight}"
// //                     </p>
// //                   </div>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>
// //         </section>
// //       </div>
// //       <section className="relative py-20 px-6 sm:px-10 min-h-[700px] bg-[#050A18]">
// //         {/* Background Image */}
// //         <div
// //           className="absolute inset-0 bg-cover bg-center -z-20"
// //           style={{ backgroundImage: "url('/images/step1.jpg')" }}
// //         />

// //         {/* Dark Overlay + Glow */}
// //         <div className="absolute inset-0 -z-10">
// //           <div className="absolute w-[500px] h-[500px] bg-[#4FA0FF]/20 blur-[130px] rounded-full top-[-100px] left-[-120px]" />
// //           <div className="absolute w-[450px] h-[450px] bg-[#1d8df5]/25 blur-[150px] rounded-full bottom-[-120px] right-[-120px]" />
// //           <div className="absolute inset-0 bg-black/50" /> {/* dark overlay */}
// //         </div>

// //         {/* Main Container */}
// //         <div className="max-w-6xl mx-auto relative z-10 ">
// //           {/* Heading */}
// //           <div className="text-center mb-12">
// //             <h2 className="text-4xl sm:text-5xl font-extrabold leading-tight text-white mb-4">
// //               Fast, Secure & Easy Loan Process
// //               <br />
// //               <span className="text-[#4FA0FF]">Designed For Your Needs</span>
// //             </h2>
// //             <p className="text-black/70 text-lg max-w-2xl mx-auto">
// //               Apply anytime and get instant approval with our seamless, digital
// //               loan application experience.
// //             </p>
// //           </div>

// //           {/* Flex Layout for Left & Right Cards */}
// //           <div className="flex flex-col md:flex-row gap-10">
// //             {/* Left Card - Steps Vertical */}
// //             <div className="flex-1 bg-[white]/10 backdrop-blur-xl border border-white/20 shadow-lg rounded-2xl p-8 flex flex-col">
// //               <h3 className="text-2xl font-bold text-white mb-6 flex items-center">
// //                 <span className="w-2 h-8 bg-[#4FA0FF] rounded-full mr-3"></span>
// //                 {"How It Works"}
// //               </h3>
// //               <ul className="space-y-6">
// //                 {[
// //                   "Fill the quick online form quickly and easily with minimal effort",
// //                   "Upload your documents securely in just a few steps",
// //                   "Receive instant approval & get funds directly into your account",
// //                 ].map((step, i) => (
// //                   <li key={i} className="flex items-start">
// //                     <div className="w-10 h-10 bg-gradient-to-br from-[#4FA0FF] to-[#1d8df5] text-white/80 flex items-center justify-center rounded-full text-lg font-bold mr-4 shadow-md">
// //                       {i + 1}
// //                     </div>
// //                     <p className="text-lg text-white/80">{step}</p>
// //                   </li>
// //                 ))}
// //               </ul>
// //             </div>

// //             {/* Right Card - CTA & Trust */}
// //             <div
// //               className="rounded-2xl p-7 bg-[white]/10 border relative overflow-hidden flex flex-col items-center"
// //               style={{
// //                 borderColor: "rgba(255, 255, 255, 0.1)",
// //                 backdropFilter: "blur(10px)",
// //               }}
// //             >
// //               {/* Decorative Gradient Circle */}
// //               <div
// //                 style={{
// //                   position: "absolute",
// //                   bottom: "-50%",
// //                   left: "-50%",
// //                   width: "200px",
// //                   height: "200px",
// //                   borderRadius: "50%",
// //                   background:
// //                     "radial-gradient(circle, rgba(79,160,255,0.15) 0%, transparent 70%)",
// //                 }}
// //               />

// //               {/* Heading */}
// //               <h3 className="text-2xl font-bold text-white mb-6 flex items-center justify-center">
// //                 <svg
// //                   className="w-7 h-7 mr-3"
// //                   fill="none"
// //                   stroke="currentColor"
// //                   viewBox="0 0 24 24"
// //                   style={{ color: "#4FA0FF" }}
// //                 >
// //                   <path
// //                     strokeLinecap="round"
// //                     strokeLinejoin="round"
// //                     strokeWidth={2}
// //                     d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
// //                   />
// //                 </svg>
// //                 Ready to Apply?
// //               </h3>

// //               {/* Buttons */}
// //               <div className="space-y-4 w-full max-w-xs flex flex-col items-center">
// //                 <a
// //                   href="/apply-now"
// //                   className="w-full font-bold rounded-xl shadow-lg transition-all duration-300 flex items-center justify-center min-h-[56px] px-8 bg-gradient-to-r from-[#4FA0FF] to-[#1d8df5] text-white text-center"
// //                 >
// //                   <span className="flex items-center justify-center text-lg">
// //                     <svg
// //                       className="w-5 h-5 mr-2"
// //                       fill="none"
// //                       stroke="currentColor"
// //                       viewBox="0 0 24 24"
// //                     >
// //                       <path
// //                         strokeLinecap="round"
// //                         strokeLinejoin="round"
// //                         strokeWidth={2}
// //                         d="M13 7l5 5m0 0l-5 5m5-5H6"
// //                       />
// //                     </svg>
// //                     Get Started Now
// //                   </span>
// //                 </a>
// //                 <a
// //                   href="#contact"
// //                   className="w-full border-2 font-bold rounded-xl transition-all duration-300 flex items-center justify-center min-h-[56px] px-8 border-[#4FA0FF] bg-transparent text-[#4FA0FF] text-center"
// //                 >
// //                   <span className="flex items-center justify-center text-white text-lg">
// //                     <svg
// //                       className="w-5 h-5 mr-2"
// //                       fill="none"
// //                       stroke="currentColor"
// //                       viewBox="0 0 24 24"
// //                     >
// //                       <path
// //                         strokeLinecap="round"
// //                         strokeLinejoin="round"
// //                         strokeWidth={2}
// //                         d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
// //                       />
// //                     </svg>
// //                     Contact Support
// //                   </span>
// //                 </a>
// //               </div>

// //               {/* Trust indicators */}
// //               <div
// //                 className="mt-6 pt-6 border-t flex flex-col items-center gap-3 w-full"
// //                 style={{ borderColor: "rgba(79,160,255,0.2)" }}
// //               >
// //                 <div className="flex items-center text-white/90 text-sm">
// //                   <svg
// //                     className="w-5 h-5 mr-2"
// //                     fill="currentColor"
// //                     viewBox="0 0 20 20"
// //                     style={{ color: "#4FA0FF" }}
// //                   >
// //                     <path
// //                       fillRule="evenodd"
// //                       d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
// //                       clipRule="evenodd"
// //                     />
// //                   </svg>
// //                   100% Secure
// //                 </div>
// //                 <div className="flex items-center text-white/90 text-sm">
// //                   <svg
// //                     className="w-5 h-5 mr-2"
// //                     fill="currentColor"
// //                     viewBox="0 0 20 20"
// //                     style={{ color: "#4FA0FF" }}
// //                   >
// //                     <path
// //                       fillRule="evenodd"
// //                       d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
// //                       clipRule="evenodd"
// //                     />
// //                   </svg>
// //                   Quick Process
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </section>
// //     </div>
// //   );
// // };

// // export default About;
// import React from "react";
// import {
//   FaRocket,
//   FaUsers,
//   FaLightbulb,
//   FaCheckCircle,
//   FaShieldAlt,
//   FaMobileAlt,
//   FaClock,
//   FaRegGem,
// } from "react-icons/fa";
// import { GiReceiveMoney, GiArchiveResearch } from "react-icons/gi";
// import { motion } from "framer-motion";

// const cardVariants = {
//   hiddenLeft: { opacity: 0, x: -100 },
//   hiddenRight: { opacity: 0, x: 100 },
//   visible: { opacity: 1, x: 0, transition: { duration: 0.7 } },
// };

// const About = () => {
//   return (
//     <div className="bg-gradient-to-b from-white via-[#F8FAF5] to-white text-gray-900 overflow-hidden">
//       {/* Hero Section - Light Theme with Green */}
//       <header className="relative text-center mb-10 py-28 px-4 overflow-hidden">
//         {/* Floating Green Waves - Background */}
//         <div className="absolute inset-0 overflow-hidden pointer-events-none">
//           <div className="absolute -top-20 -left-20 w-[500px] h-[500px] opacity-20 animate-float-slow">
//             <svg
//               viewBox="0 0 200 200"
//               xmlns="http://www.w3.org/2000/svg"
//               className="w-full h-full"
//             >
//               <path
//                 fill="#105840"
//                 fillOpacity="0.08"
//                 d="M44.7,-76.4C58.9,-69.2,72.6,-59.1,80.6,-45.5C88.6,-31.9,90.8,-14.8,88.1,1.4C85.4,17.6,77.8,32.8,68.1,46.2C58.4,59.6,46.6,71.2,32.5,78.5C18.4,85.8,2,88.8,-13.6,86.3C-29.2,83.8,-44,75.7,-57.5,65.1C-71,54.5,-83.1,41.3,-88.7,25.9C-94.3,10.5,-93.3,-7.1,-86.9,-22.3C-80.5,-37.5,-68.7,-50.4,-55.4,-58.5C-42.1,-66.6,-27.3,-70,-12.2,-73.6C2.8,-77.1,18.6,-80.8,32.8,-77.6C47,-74.4,59.5,-64.2,44.7,-76.4Z"
//                 transform="translate(100 100)"
//               />
//             </svg>
//           </div>
//           <div className="absolute -bottom-20 -right-20 w-[600px] h-[600px] opacity-20 animate-float-medium">
//             <svg
//               viewBox="0 0 200 200"
//               xmlns="http://www.w3.org/2000/svg"
//               className="w-full h-full"
//             >
//               <path
//                 fill="#105840"
//                 fillOpacity="0.06"
//                 d="M45.2,-77.9C59.2,-70.9,71.8,-59.1,79.9,-44.6C88,-30.1,91.5,-12.9,89.7,3.9C87.9,20.7,80.8,37,70.3,50.9C59.8,64.8,45.9,76.3,30.3,83.2C14.7,90.1,-2.6,92.4,-19.8,89.1C-37,85.8,-54,76.8,-67.1,63.7C-80.2,50.6,-89.3,33.4,-91.8,15.3C-94.3,-2.8,-90.2,-21.8,-80.1,-36.9C-70,-52,-53.9,-63.2,-37.7,-70.5C-21.5,-77.8,-5.2,-81.2,11.3,-81.1C27.8,-81,44.4,-77.4,45.2,-77.9Z"
//                 transform="translate(100 100)"
//               />
//             </svg>
//           </div>
//         </div>

//         {/* Animated Top Wave */}
//         <div className="absolute top-0 left-0 w-full h-64 md:h-80 lg:h-96 overflow-hidden pointer-events-none">
//           <motion.div
//             animate={{ y: [0, -15, 0, 15, 0], scale: [1, 1.02, 1, 0.98, 1] }}
//             transition={{ duration: 20, repeat: Infinity, ease: "easeInOut" }}
//             className="absolute top-0 -left-10 w-[120%] h-full"
//           >
//             <svg
//               className="absolute top-0 left-0 w-full h-full"
//               viewBox="0 0 1440 400"
//               preserveAspectRatio="none"
//             >
//               <motion.path
//                 animate={{
//                   d: [
//                     "M0,192 C220,260 440,64 720,64 C1000,64 1220,260 1440,192 L1440,0 L0,0 Z",
//                     "M0,224 C240,160 480,320 720,320 C960,320 1200,160 1440,224 L1440,0 L0,0 Z",
//                     "M0,192 C220,260 440,64 720,64 C1000,64 1220,260 1440,192 L1440,0 L0,0 Z",
//                   ],
//                 }}
//                 transition={{
//                   duration: 15,
//                   repeat: Infinity,
//                   ease: "easeInOut",
//                 }}
//                 fill="#105840"
//                 fillOpacity="0.06"
//               />
//             </svg>
//           </motion.div>
//         </div>

//         {/* Hero Content */}
//         <div className="relative z-10 max-w-4xl mx-auto">
//           <motion.div
//             initial={{ width: 0 }}
//             whileInView={{ width: "80px" }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.8 }}
//             className="h-1 bg-[#105840] mx-auto mb-6"
//           />

//           <motion.h1
//             initial={{ opacity: 0, y: 30 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6 }}
//             viewport={{ once: true }}
//             className="text-5xl md:text-6xl font-bold mb-4 text-gray-900"
//           >
//             About <span className="text-[#105840]">Salarymates</span>
//           </motion.h1>

//           <motion.p
//             initial={{ opacity: 0, y: 30 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6, delay: 0.2 }}
//             viewport={{ once: true }}
//             className="text-xl text-gray-600 leading-relaxed max-w-2xl mx-auto"
//           >
//             Revolutionizing financial solutions for salaried individuals with
//             speed, transparency, and trust
//           </motion.p>
//         </div>
//       </header>

//       {/* Main Content */}
//       <div className="max-w-6xl mx-auto px-5 relative z-10">
//         {/* Our Journey & Team Section - Light Theme */}
//         <section className="relative py-10">
//           <div className="relative bg-white rounded-2xl p-8 md:p-10 shadow-lg border border-[#105840]/10 z-10">
//             <div className="text-center mb-5">
//               <motion.div
//                 initial={{ width: 0 }}
//                 whileInView={{ width: "60px" }}
//                 viewport={{ once: true }}
//                 transition={{ duration: 0.8, delay: 0.2 }}
//                 className="h-1 bg-[#105840] mx-auto mb-6"
//               />

//               <h4 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
//                 Connect with{" "}
//                 <span className="text-[#105840]">Salarymates</span>
//               </h4>

//               <p className="text-gray-600 text-lg leading-relaxed max-w-3xl mx-auto mb-10">
//                 At Salarymates, we're driven by the mission to empower
//                 salaried individuals with financial freedom. Our dedicated team
//                 and streamlined process ensure you're supported every step of
//                 the way.
//               </p>
//             </div>

//             <div className="flex justify-center gap-8 flex-wrap mt-12">
//               {[
//                 {
//                   icon: <FaRocket className="text-2xl text-white" />,
//                   title: "Founded in 2020",
//                   content:
//                     "Started with a vision to simplify salary-based loans for working professionals",
//                 },
//                 {
//                   icon: <FaUsers className="text-2xl text-white" />,
//                   title: "50+ Team Members",
//                   content:
//                     "Dedicated professionals working to make your financial journey seamless",
//                 },
//                 {
//                   icon: <FaLightbulb className="text-2xl text-white" />,
//                   title: "1M+ Customers",
//                   content:
//                     "Trusted by over a million salaried individuals across India",
//                 },
//               ].map((item, index) => (
//                 <motion.div
//                   key={index}
//                   initial={{ opacity: 0, y: 30 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.5, delay: index * 0.1 }}
//                   viewport={{ once: true }}
//                   whileHover={{ y: -5 }}
//                   className="flex-1 min-w-[300px] bg-gradient-to-br from-[#105840]/5 to-[#105840]/10 rounded-xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 border border-[#105840]/10"
//                 >
//                   <div className="w-14 h-14 bg-[#105840] rounded-xl flex items-center justify-center text-white mb-5 shadow-lg">
//                     {item.icon}
//                   </div>
//                   <h3 className="text-xl font-semibold text-[#105840] mb-4">
//                     {item.title}
//                   </h3>
//                   <p className="text-gray-600 leading-relaxed">
//                     {item.content}
//                   </p>
//                 </motion.div>
//               ))}
//             </div>
//           </div>
//         </section>

//         {/* === Cards Section - Light Theme with Green === */}
//         {[
//           {
//             title: "Instant Loan Approval",
//             description:
//               "Apply and get approved for a loan within minutes. Our automated system ensures that you receive instant decisions based on your profile.",
//             image: "/images/about/about-1.jpg",
//             icon: <GiReceiveMoney className="text-[#105840] text-3xl" />,
//             reverse: false,
//             points: [
//               {
//                 text: "Approval in as little as 5 minutes",
//                 icon: <FaClock className="text-[#105840] mr-3" />,
//               },
//               {
//                 text: "24/7 application processing",
//                 icon: <FaCheckCircle className="text-[#105840] mr-3" />,
//               },
//               {
//                 text: "Real-time status updates",
//                 icon: <FaMobileAlt className="text-[#105840] mr-3" />,
//               },
//             ],
//           },
//           {
//             title: "100% Digital Process",
//             description:
//               "Experience a paperless journey from start to finish. Upload your documents, verify your details, and get disbursal—all online.",
//             image: "/images/about/about-2.jpg",
//             icon: <GiArchiveResearch className="text-[#105840] text-3xl" />,
//             reverse: true,
//             points: [
//               {
//                 text: "No physical paperwork required",
//                 icon: <FaCheckCircle className="text-[#105840] mr-3" />,
//               },
//               {
//                 text: "eKYC and digital signatures",
//                 icon: <FaCheckCircle className="text-[#105840] mr-3" />,
//               },
//               {
//                 text: "Instant document verification",
//                 icon: <FaCheckCircle className="text-[#105840] mr-3" />,
//               },
//             ],
//           },
//           {
//             title: "Secure & Trusted",
//             description:
//               "Your data is safe with us. We use industry-grade encryption and privacy standards to keep your information secure at all times.",
//             image: "/images/about/about-3.jpg",
//             icon: <FaShieldAlt className="text-[#105840] text-3xl" />,
//             reverse: false,
//             points: [
//               {
//                 text: "Bank-level security protocols",
//                 icon: <FaCheckCircle className="text-[#105840] mr-3" />,
//               },
//               {
//                 text: "Regular security audits",
//                 icon: <FaCheckCircle className="text-[#105840] mr-3" />,
//               },
//               {
//                 text: "GDPR compliant data handling",
//                 icon: <FaCheckCircle className="text-[#105840] mr-3" />,
//               },
//             ],
//           },
//         ].map((feature, index) => (
//           <motion.section
//             key={index}
//             initial={feature.reverse ? "hiddenRight" : "hiddenLeft"}
//             whileInView="visible"
//             viewport={{ once: true, amount: 0.2 }}
//             variants={cardVariants}
//             className={`my-16 rounded-2xl overflow-hidden flex flex-col md:flex-row ${
//               feature.reverse ? "md:flex-row-reverse" : ""
//             } shadow-lg border border-[#105840]/10 bg-white`}
//           >
//             <div className="flex-1 min-w-[300px] p-8 md:p-12 flex flex-col justify-center">
//               <div className="flex items-center mb-5">
//                 <div className="w-12 h-12 bg-[#105840]/10 rounded-lg flex items-center justify-center shadow-md mr-4 border border-[#105840]/20">
//                   {feature.icon}
//                 </div>
//                 <h2 className="text-2xl font-bold text-gray-900 m-0">
//                   {feature.title}
//                 </h2>
//               </div>
//               <p className="text-gray-600 text-lg leading-relaxed mb-8">
//                 {feature.description}
//               </p>
//               <ul className="list-none p-0 m-0">
//                 {feature.points.map((point, i) => (
//                   <li key={i} className="flex items-center mb-3 text-gray-700">
//                     {point.icon}
//                     {point.text}
//                   </li>
//                 ))}
//               </ul>
//             </div>
//             <div className="flex-1 min-w-[300px] min-h-[400px] relative flex items-center justify-center p-0 overflow-hidden">
//               <div
//                 className={`absolute inset-0 ${
//                   feature.reverse ? "bg-gradient-to-r" : "bg-gradient-to-l"
//                 } from-[#105840]/10 to-transparent`}
//               ></div>
//               <img
//                 src={feature.image}
//                 alt={feature.title}
//                 className="relative z-10 w-full h-full max-h-[400px] object-cover shadow-lg transition-transform duration-500 hover:scale-105"
//               />
//             </div>
//           </motion.section>
//         ))}

//         {/* Vision & Mission Section - Light Theme with Green */}
//         <section className="relative py-10 overflow-hidden">
//           {/* Decorative Green Elements */}
//           <div className="absolute -top-32 -left-32 w-96 h-96 bg-[#105840]/5 rounded-full blur-3xl"></div>
//           <div className="absolute -bottom-40 -right-40 w-96 h-96 bg-[#105840]/5 rounded-full blur-3xl"></div>

//           <div className="max-w-7xl mx-auto px-3 md:px-6">
//             <div className="text-center mb-16">
//               <motion.div
//                 initial={{ width: 0 }}
//                 whileInView={{ width: "80px" }}
//                 viewport={{ once: true }}
//                 transition={{ duration: 0.8 }}
//                 className="h-1 bg-[#105840] mx-auto mb-6"
//               />

//               <h2 className="text-4xl font-bold text-gray-900 mb-4">
//                 Our Core Beliefs
//               </h2>
//               <p className="text-lg text-gray-600 max-w-2xl mx-auto">
//                 The foundation of everything we do at Salarymates
//               </p>
//             </div>

//             <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 relative z-10">
//               {[
//                 {
//                   title: "Our Mission",
//                   icon: (
//                     <div className="relative">
//                       <div className="absolute -inset-4 bg-[#105840] rounded-full opacity-10"></div>
//                       <FaRocket className="text-5xl text-[#105840] transform transition-all duration-500 group-hover:rotate-12" />
//                     </div>
//                   ),
//                   content:
//                     "Our mission is to simplify and speed up personal financing for salaried professionals by providing quick, secure, and transparent loan services that empower individuals to meet their financial needs without the traditional banking hassles.",
//                   highlight:
//                     "Empowering salaried professionals with instant financial solutions",
//                   gradient: "from-[#105840] to-[#0A4A30]",
//                 },
//                 {
//                   title: "Our Vision",
//                   icon: (
//                     <div className="relative">
//                       <div className="absolute -inset-4 bg-[#105840] rounded-full opacity-10"></div>
//                       <FaRegGem className="text-5xl text-[#105840] transform transition-all duration-500 group-hover:scale-110" />
//                     </div>
//                   ),
//                   content:
//                     "To become India's most trusted short-term loan platform for the salaried workforce, offering unmatched convenience, reliability, and financial freedom through innovative digital solutions.",
//                   highlight: "Leading the future of digital lending in India",
//                   gradient: "from-[#0A4A30] to-[#105840]",
//                 },
//               ].map((card, index) => (
//                 <motion.div
//                   key={index}
//                   initial={{ opacity: 0, y: 30 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.5, delay: index * 0.1 }}
//                   viewport={{ once: true }}
//                   whileHover={{ y: -5 }}
//                   className="group relative bg-white rounded-3xl p-8 shadow-xl border border-[#105840]/10 overflow-hidden transition-all duration-500 hover:shadow-2xl"
//                 >
//                   {/* Gradient top border */}
//                   <div
//                     className={`absolute top-0 left-0 w-full h-2 bg-gradient-to-r ${card.gradient}`}
//                   ></div>

//                   {/* Floating icon with halo effect */}
//                   <div className="mt-4 mb-8 flex justify-center">
//                     {card.icon}
//                   </div>

//                   <h3 className="text-3xl font-bold text-[#105840] mb-6 text-center">
//                     {card.title}
//                   </h3>

//                   <p className="text-gray-600 text-lg leading-relaxed mb-8 text-center">
//                     {card.content}
//                   </p>

//                   <div className="mt-8 p-6 bg-gradient-to-r from-[#105840]/5 to-[#0A4A30]/5 rounded-xl border-l-4 border-[#105840] transition-all duration-500 group-hover:bg-gradient-to-r group-hover:from-[#105840]/10 group-hover:to-[#0A4A30]/10">
//                     <p className="text-[#105840] font-bold m-0 italic text-lg text-center">
//                       "{card.highlight}"
//                     </p>
//                   </div>
//                 </motion.div>
//               ))}
//             </div>
//           </div>
//         </section>
//       </div>

//       {/* Fast, Secure & Easy Loan Process Section - Light Theme */}
//       <section className="relative py-20 px-6 sm:px-10 min-h-[700px] bg-gradient-to-br from-white to-[#F8FAF5] overflow-hidden">
//         {/* Floating Green Waves */}
//         <div className="absolute inset-0 overflow-hidden pointer-events-none">
//           <div className="absolute top-20 right-20 w-[400px] h-[400px] bg-[#105840]/5 rounded-full blur-3xl animate-float-slow"></div>
//           <div className="absolute bottom-20 left-20 w-[500px] h-[500px] bg-[#105840]/5 rounded-full blur-3xl animate-float-medium"></div>
//         </div>

//         {/* Animated Wave Pattern */}
//         <div className="absolute top-0 left-0 w-full h-64 overflow-hidden pointer-events-none">
//           <motion.div
//             animate={{ y: [0, -10, 0] }}
//             transition={{ duration: 15, repeat: Infinity, ease: "easeInOut" }}
//             className="w-full"
//           >
//             <svg
//               className="w-full h-32"
//               viewBox="0 0 1440 120"
//               preserveAspectRatio="none"
//             >
//               <path
//                 fill="#105840"
//                 fillOpacity="0.05"
//                 d="M0,64 C240,96 480,32 720,32 C960,32 1200,96 1440,64 L1440,0 L0,0 Z"
//               />
//             </svg>
//           </motion.div>
//         </div>

//         {/* Main Container */}
//         <div className="max-w-6xl mx-auto relative z-10">
//           {/* Heading */}
//           <motion.div
//             initial={{ opacity: 0, y: 30 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6 }}
//             viewport={{ once: true }}
//             className="text-center mb-12"
//           >
//             <motion.div
//               initial={{ width: 0 }}
//               whileInView={{ width: "80px" }}
//               viewport={{ once: true }}
//               transition={{ duration: 0.8, delay: 0.2 }}
//               className="h-1 bg-[#105840] mx-auto mb-6"
//             />

//             <h2 className="text-4xl sm:text-5xl font-bold leading-tight text-gray-900 mb-4">
//               Fast, Secure & Easy Loan Process
//               <br />
//               <span className="text-[#105840]">Designed For Your Needs</span>
//             </h2>
//             <p className="text-gray-600 text-lg max-w-2xl mx-auto">
//               Apply anytime and get instant approval with our seamless, digital
//               loan application experience.
//             </p>
//           </motion.div>

//           {/* Flex Layout for Left & Right Cards */}
//           <div className="flex flex-col md:flex-row gap-10">
//             {/* Left Card - Steps Vertical */}
//             <motion.div
//               initial={{ opacity: 0, x: -30 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.6, delay: 0.3 }}
//               viewport={{ once: true }}
//               className="flex-1 bg-white shadow-xl border border-[#105840]/10 rounded-2xl p-8 flex flex-col"
//             >
//               <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
//                 <span className="w-2 h-8 bg-[#105840] rounded-full mr-3"></span>
//                 How It Works
//               </h3>
//               <ul className="space-y-6">
//                 {[
//                   "Fill the quick online form quickly and easily with minimal effort",
//                   "Upload your documents securely in just a few steps",
//                   "Receive instant approval & get funds directly into your account",
//                 ].map((step, i) => (
//                   <li key={i} className="flex items-start group">
//                     <motion.div
//                       whileHover={{ scale: 1.1 }}
//                       className="w-10 h-10 bg-gradient-to-br from-[#105840] to-[#0A4A30] text-white flex items-center justify-center rounded-full text-lg font-bold mr-4 shadow-md"
//                     >
//                       {i + 1}
//                     </motion.div>
//                     <p className="text-lg text-gray-700">{step}</p>
//                   </li>
//                 ))}
//               </ul>
//             </motion.div>

//             {/* Right Card - CTA & Trust */}
//             <motion.div
//               initial={{ opacity: 0, x: 30 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.6, delay: 0.4 }}
//               viewport={{ once: true }}
//               className="flex-1 bg-white rounded-2xl p-8 shadow-xl border border-[#105840]/10 relative overflow-hidden flex flex-col items-center"
//             >
//               {/* Decorative Gradient Circle */}
//               <div className="absolute -bottom-20 -left-20 w-64 h-64 bg-[#105840]/5 rounded-full blur-3xl"></div>
//               <div className="absolute -top-20 -right-20 w-64 h-64 bg-[#105840]/5 rounded-full blur-3xl"></div>

//               {/* Heading */}
//               <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center justify-center">
//                 <FaRegGem className="w-7 h-7 mr-3 text-[#105840]" />
//                 Ready to Apply?
//               </h3>

//               {/* Buttons */}
//               <div className="space-y-4 w-full max-w-xs flex flex-col items-center relative z-10">
//                 <motion.a
//                   whileHover={{ scale: 1.05, y: -2 }}
//                   whileTap={{ scale: 0.95 }}
//                   href="/apply-now"
//                   className="w-full font-bold rounded-xl shadow-lg transition-all duration-300 flex items-center justify-center min-h-[56px] px-8 bg-gradient-to-r from-[#105840] to-[#0A4A30] text-white text-center"
//                 >
//                   <span className="flex items-center justify-center text-lg">
//                     <svg
//                       className="w-5 h-5 mr-2"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M13 7l5 5m0 0l-5 5m5-5H6"
//                       />
//                     </svg>
//                     Get Started Now
//                   </span>
//                 </motion.a>
//                 <motion.a
//                   whileHover={{ scale: 1.05, y: -2 }}
//                   whileTap={{ scale: 0.95 }}
//                   href="#contact"
//                   className="w-full border-2 font-bold rounded-xl transition-all duration-300 flex items-center justify-center min-h-[56px] px-8 border-[#105840]/30 bg-transparent text-[#105840] hover:border-[#105840] hover:bg-[#105840]/5 text-center"
//                 >
//                   <span className="flex items-center justify-center text-lg">
//                     <svg
//                       className="w-5 h-5 mr-2"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
//                       />
//                     </svg>
//                     Contact Support
//                   </span>
//                 </motion.a>
//               </div>

//               {/* Trust indicators */}
//               <div className="mt-6 pt-6 border-t border-[#105840]/10 flex flex-col items-center gap-3 w-full">
//                 <div className="flex items-center text-gray-700 text-sm">
//                   <FaShieldAlt className="w-5 h-5 mr-2 text-[#105840]" />
//                   100% Secure
//                 </div>
//                 <div className="flex items-center text-gray-700 text-sm">
//                   <FaClock className="w-5 h-5 mr-2 text-[#105840]" />
//                   Quick Process
//                 </div>
//               </div>
//             </motion.div>
//           </div>
//         </div>

//         {/* Bottom Wave */}
//         <div className="absolute bottom-0 left-0 w-full overflow-hidden pointer-events-none">
//           <motion.div
//             animate={{ x: ["0%", "2%", "0%"], y: [0, 5, 0] }}
//             transition={{ duration: 16, repeat: Infinity, ease: "easeInOut" }}
//             className="relative w-[110%] -left-[5%]"
//           >
//             <svg
//               className="relative block w-full h-16 md:h-20"
//               viewBox="0 0 1440 120"
//               preserveAspectRatio="none"
//             >
//               <motion.path
//                 animate={{
//                   d: [
//                     "M0,64 C240,96 480,32 720,32 C960,32 1200,96 1440,64 L1440,120 L0,120 Z",
//                     "M0,80 C240,48 480,112 720,112 C960,112 1200,48 1440,80 L1440,120 L0,120 Z",
//                     "M0,64 C240,96 480,32 720,32 C960,32 1200,96 1440,64 L1440,120 L0,120 Z",
//                   ],
//                 }}
//                 transition={{
//                   duration: 12,
//                   repeat: Infinity,
//                   ease: "easeInOut",
//                 }}
//                 fill="#105840"
//                 fillOpacity="0.05"
//               />
//             </svg>
//           </motion.div>
//         </div>
//       </section>

//       {/* Custom Animations */}
//       <style jsx>{`
//         @keyframes float-slow {
//           0%,
//           100% {
//             transform: translate(0, 0) rotate(0deg);
//           }
//           33% {
//             transform: translate(30px, -30px) rotate(5deg);
//           }
//           66% {
//             transform: translate(-20px, 20px) rotate(-3deg);
//           }
//         }
//         @keyframes float-medium {
//           0%,
//           100% {
//             transform: translate(0, 0) rotate(0deg);
//           }
//           25% {
//             transform: translate(-40px, 20px) rotate(-8deg);
//           }
//           75% {
//             transform: translate(40px, -20px) rotate(8deg);
//           }
//         }
//         .animate-float-slow {
//           animation: float-slow 20s ease-in-out infinite;
//         }
//         .animate-float-medium {
//           animation: float-medium 18s ease-in-out infinite;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default About;
import React from "react";
import {
  FaArrowRight,
  FaCheckCircle,
  FaQuoteRight,
  FaChartLine,
  FaHandshake,
  FaBuilding,
  FaShieldAlt,
  FaClock,
  FaUsers,
  FaRocket,
  FaRegGem,
  FaStar,
  FaAward,
  FaLinkedin,
  FaTwitter,
  FaEnvelope,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

const About = () => {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start start", "end end"],
  });

  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.1]);
  const opacity = useTransform(scrollYProgress, [0, 0.5, 1], [1, 0.8, 0.6]);

  // Parallax effect for images
  const imageVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.8, ease: [0.25, 0.1, 0, 1] },
    },
  };

  // Stagger children animations
  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: [0.25, 0.1, 0, 1] },
    },
  };

  return (
    // <div className="bg-white overflow-hidden" ref={containerRef}>
    //   {/* Hero Section with Top Wave */}
    //   <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden px-4 sm:px-8 lg:px-12 xl:px-16">
    //     {/* Floating Elements with Enhanced Animations */}
    //     <div className="absolute inset-0 pointer-events-none">
    //       <motion.div
    //         animate={{
    //           y: [0, -40, 0],
    //           x: [0, 30, 0],
    //           rotate: [0, 10, -10, 0],
    //           scale: [1, 1.1, 1],
    //         }}
    //         transition={{ duration: 25, repeat: Infinity, ease: "easeInOut" }}
    //         className="absolute top-20 left-[5%] w-72 h-72 bg-[#105840]/5 rounded-full blur-3xl"
    //       />
    //       <motion.div
    //         animate={{
    //           y: [0, 40, 0],
    //           x: [0, -30, 0],
    //           rotate: [0, -10, 10, 0],
    //           scale: [1, 1.2, 1],
    //         }}
    //         transition={{ duration: 22, repeat: Infinity, ease: "easeInOut" }}
    //         className="absolute bottom-20 right-[5%] w-96 h-96 bg-[#105840]/5 rounded-full blur-3xl"
    //       />
    //       <motion.div
    //         animate={{
    //           scale: [1, 1.3, 1],
    //           opacity: [0.2, 0.4, 0.2],
    //           rotate: [0, 180, 360],
    //         }}
    //         transition={{ duration: 15, repeat: Infinity, ease: "linear" }}
    //         className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#105840]/5 rounded-full blur-3xl"
    //       />
    //     </div>

    //     {/* Floating Particles with Enhanced Animation */}
    //     <div className="absolute inset-0 pointer-events-none">
    //       {[...Array(12)].map((_, i) => (
    //         <motion.div
    //           key={i}
    //           initial={{ opacity: 0, scale: 0 }}
    //           animate={{
    //             opacity: [0, 0.6, 0],
    //             scale: [0, 1.2, 0],
    //             x: Math.random() * window.innerWidth,
    //             y: Math.random() * window.innerHeight,
    //           }}
    //           transition={{
    //             duration: 10 + i * 2,
    //             repeat: Infinity,
    //             delay: i * 0.8,
    //             ease: "easeInOut",
    //           }}
    //           className="absolute w-3 h-3 bg-[#105840]/20 rounded-full"
    //         />
    //       ))}
    //     </div>

    //     {/* Top Wave - Increased Height */}
    //     <div className="absolute top-0 left-0 w-full pointer-events-none">
    //       <svg
    //         className="w-full h-48 md:h-64"
    //         viewBox="0 0 1440 300"
    //         preserveAspectRatio="none"
    //       >
    //         <motion.path
    //           animate={{
    //             d: [
    //               "M0,150 C300,225 600,75 900,150 C1200,225 1440,75 1440,150 L1440,0 L0,0 Z",
    //               "M0,195 C300,120 600,270 900,195 C1200,120 1440,270 1440,195 L1440,0 L0,0 Z",
    //               "M0,150 C300,225 600,75 900,150 C1200,225 1440,75 1440,150 L1440,0 L0,0 Z",
    //             ],
    //           }}
    //           transition={{ duration: 12, repeat: Infinity, ease: "easeInOut" }}
    //           fill="#105840"
    //           fillOpacity="0.05"
    //         />
    //         <motion.path
    //           animate={{
    //             d: [
    //               "M0,105 C300,165 600,45 900,105 C1200,165 1440,45 1440,105 L1440,0 L0,0 Z",
    //               "M0,135 C300,75 600,195 900,135 C1200,75 1440,195 1440,135 L1440,0 L0,0 Z",
    //               "M0,105 C300,165 600,45 900,105 C1200,165 1440,45 1440,105 L1440,0 L0,0 Z",
    //             ],
    //           }}
    //           transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
    //           fill="#105840"
    //           fillOpacity="0.03"
    //         />
    //       </svg>
    //     </div>

    //     <motion.div
    //       className="relative z-10 max-w-7xl mx-auto text-center"
    //       variants={staggerContainer}
    //       initial="hidden"
    //       whileInView="visible"
    //       viewport={{ once: true, amount: 0.3 }}
    //     >
    //       <motion.div
    //         variants={fadeInUp}
    //         className="inline-flex items-center gap-2 px-4 py-2 bg-[#105840]/5 border border-[#105840]/10 rounded-full mb-8"
    //       >
    //         <motion.span
    //           animate={{ scale: [1, 1.3, 1] }}
    //           transition={{ duration: 2, repeat: Infinity }}
    //           className="w-2 h-2 bg-[#105840] rounded-full"
    //         />
    //         <span className="text-sm font-medium text-[#105840]">
    //           SALARYMATES
    //         </span>
    //       </motion.div>

    //       <motion.div
    //         variants={fadeInUp}
    //         className="h-1 bg-[#105840] mx-auto mb-6"
    //         style={{ width: "80px" }}
    //       />

    //       <motion.h1
    //         variants={fadeInUp}
    //         className="text-5xl md:text-7xl font-bold text-gray-900 mb-6 tracking-tight"
    //       >
    //         We're building the
    //         <span className="relative ml-3">
    //           <span className="relative z-10 text-[#105840]">future</span>
    //           <motion.span
    //             initial={{ width: 0 }}
    //             whileInView={{ width: "100%" }}
    //             transition={{ duration: 0.8, delay: 0.5 }}
    //             className="absolute -bottom-2 left-0 w-full h-3 bg-[#105840]/10 rounded-full"
    //           />
    //         </span>
    //         <br />
    //         of salary lending.
    //       </motion.h1>

    //       <motion.p
    //         variants={fadeInUp}
    //         className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed"
    //       >
    //         A new standard for short-term credit — transparent, fair, and built
    //         for the way you work today.
    //       </motion.p>
    //     </motion.div>
    //   </section>

    //   {/* Founded Section - Added */}
    //   <section className="relative py-20 pt-5 px-4 sm:px-8 lg:px-12 xl:px-16">
    //     <div className="max-w-7xl mx-auto">
    //       <motion.div
    //         initial={{ opacity: 0, y: 30 }}
    //         whileInView={{ opacity: 1, y: 0 }}
    //         transition={{ duration: 0.6 }}
    //         viewport={{ once: true }}
    //         className="text-center"
    //       >
    //         <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#105840]/5 border border-[#105840]/10 rounded-full mb-4">
    //           <span className="w-1.5 h-1.5 bg-[#105840] rounded-full animate-pulse" />
    //           <span className="text-xs font-medium text-[#105840]">
    //             OUR JOURNEY
    //           </span>
    //         </div>

    //         <motion.div
    //           initial={{ width: 0 }}
    //           whileInView={{ width: "60px" }}
    //           transition={{ duration: 0.8 }}
    //           className="h-1 bg-[#105840] mx-auto mb-6"
    //         />

    //         <div className="grid md:grid-cols-3 gap-8 mt-12">
    //           {[
    //             {
    //               icon: <FaRocket className="text-3xl text-white" />,
    //               title: "Founded in 2020",
    //               desc: "Started with a vision to simplify salary-based loans for working professionals",
    //             },
    //             {
    //               icon: <FaUsers className="text-3xl text-white" />,
    //               title: "50+ Team Members",
    //               desc: "Dedicated professionals working to make your financial journey seamless",
    //             },
    //             {
    //               icon: <FaRegGem className="text-3xl text-white" />,
    //               title: "1M+ Customers",
    //               desc: "Trusted by over a million salaried individuals across India",
    //             },
    //           ].map((item, i) => (
    //             <motion.div
    //               key={i}
    //               variants={fadeInUp}
    //               whileHover={{ y: -8 }}
    //               className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100"
    //             >
    //               <div className="w-16 h-16 bg-[#105840] rounded-xl flex items-center justify-center mb-6 mx-auto">
    //                 {item.icon}
    //               </div>
    //               <h3 className="text-xl font-bold text-gray-900 mb-3">
    //                 {item.title}
    //               </h3>
    //               <p className="text-gray-600">{item.desc}</p>
    //             </motion.div>
    //           ))}
    //         </div>
    //       </motion.div>
    //     </div>
    //   </section>

    //   {/* Stats Section with Top and Bottom Waves */}
    //   <section className="relative py-28 px-4 sm:px-8 lg:px-12 xl:px-16">
    //     {/* Top Wave - Increased Height */}
    //     <div className="absolute top-0 left-0 w-full pointer-events-none rotate-180">
    //       <svg
    //         className="w-full h-32 md:h-40"
    //         viewBox="0 0 1440 200"
    //         preserveAspectRatio="none"
    //       >
    //         <motion.path
    //           animate={{
    //             d: [
    //               "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //               "M0,133 C300,100 600,167 900,133 C1200,100 1440,167 1440,133 L1440,200 L0,200 Z",
    //               "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //             ],
    //           }}
    //           transition={{ duration: 8, repeat: Infinity }}
    //           fill="#105840"
    //           fillOpacity="0.03"
    //         />
    //       </svg>
    //     </div>

    //     <div className="max-w-7xl mx-auto">
    //       <motion.div
    //         className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-12"
    //         variants={staggerContainer}
    //         initial="hidden"
    //         whileInView="visible"
    //         viewport={{ once: true, amount: 0.3 }}
    //       >
    //         {[
    //           {
    //             value: "₹1,200Cr+",
    //             label: "Loan Disbursed",
    //             icon: "💰",
    //             gradient: "from-amber-500 to-orange-500",
    //           },
    //           {
    //             value: "10L+",
    //             label: "Happy Borrowers",
    //             icon: "👥",
    //             gradient: "from-blue-500 to-cyan-500",
    //           },
    //           {
    //             value: "4.2min",
    //             label: "Avg. Approval",
    //             icon: "⚡",
    //             gradient: "from-purple-500 to-pink-500",
    //           },
    //           {
    //             value: "50+",
    //             label: "Banking Partners",
    //             icon: "🤝",
    //             gradient: "from-emerald-500 to-green-500",
    //           },
    //         ].map((stat, i) => (
    //           <motion.div
    //             key={i}
    //             variants={fadeInUp}
    //             whileHover={{
    //               y: -8,
    //               scale: 1.02,
    //               transition: { type: "spring", stiffness: 400, damping: 10 },
    //             }}
    //             className="relative group"
    //           >
    //             <motion.div
    //               className="absolute -inset-4 bg-gradient-to-r opacity-0 group-hover:opacity-100 blur-xl transition-all duration-700"
    //               style={{
    //                 background: `linear-gradient(135deg, ${stat.gradient})`,
    //               }}
    //             />
    //             <div className="relative bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100">
    //               <motion.div
    //                 animate={{
    //                   scale: [1, 1.2, 1],
    //                   rotate: [0, 10, -10, 0],
    //                 }}
    //                 transition={{
    //                   duration: 4,
    //                   delay: i * 0.3,
    //                   repeat: Infinity,
    //                 }}
    //                 className="text-5xl mb-4"
    //               >
    //                 {stat.icon}
    //               </motion.div>
    //               <motion.div
    //                 className="text-3xl md:text-4xl font-bold text-[#105840] mb-2"
    //                 initial={{ opacity: 0, y: 20 }}
    //                 whileInView={{ opacity: 1, y: 0 }}
    //                 transition={{ delay: 0.2 + i * 0.1 }}
    //               >
    //                 {stat.value}
    //               </motion.div>
    //               <div className="text-sm text-gray-500">{stat.label}</div>

    //               {/* Animated Progress Bar */}
    //               <motion.div
    //                 className="absolute bottom-0 left-0 h-1 bg-gradient-to-r from-[#105840] to-[#0A4A30] rounded-b-2xl"
    //                 initial={{ width: 0 }}
    //                 whileInView={{ width: "100%" }}
    //                 transition={{ duration: 1, delay: 0.5 + i * 0.1 }}
    //               />
    //             </div>
    //           </motion.div>
    //         ))}
    //       </motion.div>
    //     </div>

    //     {/* Bottom Wave - Increased Height */}
    //     <div className="absolute bottom-0 left-0 w-full pointer-events-none">
    //       <svg
    //         className="w-full h-32 md:h-40"
    //         viewBox="0 0 1440 200"
    //         preserveAspectRatio="none"
    //       >
    //         <motion.path
    //           animate={{
    //             d: [
    //               "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //               "M0,133 C300,100 600,167 900,133 C1200,100 1440,167 1440,133 L1440,200 L0,200 Z",
    //               "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //             ],
    //           }}
    //           transition={{ duration: 8, repeat: Infinity }}
    //           fill="#105840"
    //           fillOpacity="0.03"
    //         />
    //       </svg>
    //     </div>
    //   </section>

    //   {/* Philosophy Section with Top and Bottom Waves */}
    //   <section className="relative py-28 pt-5 px-4 sm:px-8 lg:px-12 xl:px-16 overflow-hidden bg-gradient-to-br from-white to-[#F8FAF5]">
    //     {/* Top Wave - Increased Height */}
    //     <div className="absolute top-0 left-0 w-full pointer-events-none rotate-180">
    //       <svg
    //         className="w-full h-32 md:h-40"
    //         viewBox="0 0 1440 200"
    //         preserveAspectRatio="none"
    //       >
    //         <motion.path
    //           animate={{
    //             d: [
    //               "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //               "M0,133 C300,100 600,167 900,133 C1200,100 1440,167 1440,133 L1440,200 L0,200 Z",
    //               "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //             ],
    //           }}
    //           transition={{ duration: 8, repeat: Infinity }}
    //           fill="#105840"
    //           fillOpacity="0.03"
    //         />
    //       </svg>
    //     </div>

    //     <div className="max-w-7xl mx-auto">
    //       <div className="grid lg:grid-cols-2 gap-20 items-center">
    //         <motion.div
    //           initial={{ opacity: 0, x: -50 }}
    //           whileInView={{ opacity: 1, x: 0 }}
    //           transition={{ duration: 0.8, ease: [0.25, 0.1, 0, 1] }}
    //           viewport={{ once: true }}
    //         >
    //           <motion.div
    //             className="inline-flex items-center gap-2 px-3 py-1 bg-[#105840]/5 border border-[#105840]/10 rounded-full mb-4"
    //             whileHover={{ scale: 1.05 }}
    //           >
    //             <span className="w-1.5 h-1.5 bg-[#105840] rounded-full animate-pulse" />
    //             <span className="text-xs font-medium text-[#105840]">
    //               OUR PHILOSOPHY
    //             </span>
    //           </motion.div>

    //           <motion.div
    //             initial={{ width: 0 }}
    //             whileInView={{ width: "60px" }}
    //             transition={{ duration: 0.8 }}
    //             className="h-1 bg-[#105840] mb-3"
    //           />

    //           <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-2 leading-tight">
    //             Lending,
    //             <span className="text-[#105840] block mt-2">
    //               reimagined for you.
    //             </span>
    //           </h2>

    //           <p className="text-lg text-gray-600 leading-relaxed mb-8">
    //             We believe financial products should be simple. No fine print,
    //             no hidden fees, no complicated terms. Just fair, transparent
    //             access to credit when you need it.
    //           </p>

    //           <div className="space-y-4">
    //             {[
    //               "No hidden charges — ever",
    //               "Clear terms, simple language",
    //               "Decisions in minutes, not days",
    //               "24/7 customer support",
    //             ].map((item, i) => (
    //               <motion.div
    //                 key={i}
    //                 initial={{ opacity: 0, x: -30 }}
    //                 whileInView={{ opacity: 1, x: 0 }}
    //                 transition={{ duration: 0.5, delay: i * 0.1 }}
    //                 viewport={{ once: true }}
    //                 whileHover={{ x: 5 }}
    //                 className="flex items-center gap-3 group"
    //               >
    //                 <motion.div
    //                   whileHover={{ scale: 1.2, backgroundColor: "#105840" }}
    //                   className="w-6 h-6 bg-[#105840]/10 rounded-full flex items-center justify-center"
    //                 >
    //                   <span className="text-[#105840] group-hover:text-white transition-colors">
    //                     ✓
    //                   </span>
    //                 </motion.div>
    //                 <span className="text-gray-700">{item}</span>
    //               </motion.div>
    //             ))}
    //           </div>
    //         </motion.div>

    //         <motion.div
    //           initial={{ opacity: 0, x: 50, scale: 0.9 }}
    //           whileInView={{ opacity: 1, x: 0, scale: 1 }}
    //           transition={{ duration: 0.8, ease: [0.25, 0.1, 0, 1] }}
    //           viewport={{ once: true }}
    //           className="relative"
    //         >
    //           <div className="relative h-[500px] rounded-2xl overflow-hidden shadow-2xl group">
    //             <motion.img
    //               src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
    //               alt="Team Collaboration"
    //               className="w-full h-full object-cover"
    //               whileHover={{ scale: 1.1 }}
    //               transition={{ duration: 6 }}
    //             />
    //             <div className="absolute inset-0 bg-gradient-to-t from-[#105840]/50 via-transparent to-transparent" />

    //             <motion.div
    //               animate={{
    //                 y: [0, -15, 0],
    //                 rotate: [0, 2, -2, 0],
    //               }}
    //               transition={{ duration: 6, repeat: Infinity }}
    //               className="absolute bottom-8 left-8 right-8 bg-white/95 backdrop-blur-sm p-6 rounded-xl shadow-2xl border border-white/20"
    //             >
    //               <div className="flex items-center gap-4">
    //                 <motion.div
    //                   whileHover={{ scale: 1.1, rotate: 360 }}
    //                   transition={{ duration: 0.5 }}
    //                   className="w-14 h-14 bg-gradient-to-br from-[#105840] to-[#0A4A30] rounded-xl flex items-center justify-center shadow-lg"
    //                 >
    //                   <FaUsers className="text-white text-2xl" />
    //                 </motion.div>
    //                 <div>
    //                   <div className="text-lg font-bold text-gray-900">
    //                     50+ Team Members
    //                   </div>
    //                   <div className="text-sm text-gray-500">
    //                     Dedicated to your success
    //                   </div>
    //                   <div className="flex gap-2 mt-2">
    //                     <FaLinkedin className="text-gray-400 hover:text-[#105840] cursor-pointer transition-colors" />
    //                     <FaTwitter className="text-gray-400 hover:text-[#105840] cursor-pointer transition-colors" />
    //                     <FaEnvelope className="text-gray-400 hover:text-[#105840] cursor-pointer transition-colors" />
    //                   </div>
    //                 </div>
    //               </div>
    //             </motion.div>

    //             {/* Floating Badges */}
    //             <motion.div
    //               animate={{ y: [0, -10, 0], x: [0, 5, 0] }}
    //               transition={{ duration: 4, repeat: Infinity }}
    //               className="absolute top-8 right-8 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full shadow-lg"
    //             >
    //               <span className="text-sm font-semibold text-[#105840]">
    //                 ✨ 4.9 Rating
    //               </span>
    //             </motion.div>
    //           </div>
    //         </motion.div>
    //       </div>
    //     </div>

    //     {/* Bottom Wave - Increased Height */}
    //     <div className="absolute bottom-0 left-0 w-full pointer-events-none">
    //       <svg
    //         className="w-full h-32 md:h-40"
    //         viewBox="0 0 1440 200"
    //         preserveAspectRatio="none"
    //       >
    //         <motion.path
    //           animate={{
    //             d: [
    //               "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //               "M0,133 C300,100 600,167 900,133 C1200,100 1440,167 1440,133 L1440,200 L0,200 Z",
    //               "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //             ],
    //           }}
    //           transition={{ duration: 8, repeat: Infinity }}
    //           fill="#105840"
    //           fillOpacity="0.03"
    //         />
    //       </svg>
    //     </div>
    //   </section>

    //   {/* Products Section with Top and Bottom Waves */}
    //   <section className="relative py-28 px-4 sm:px-8 lg:px-12 xl:px-16 overflow-hidden">
    //     {/* Top Wave - Increased Height */}
    //     <div className="absolute top-0 left-0 w-full pointer-events-none rotate-180">
    //       <svg
    //         className="w-full h-32 md:h-40"
    //         viewBox="0 0 1440 200"
    //         preserveAspectRatio="none"
    //       >
    //         <motion.path
    //           animate={{
    //             d: [
    //               "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //               "M0,133 C300,100 600,167 900,133 C1200,100 1440,167 1440,133 L1440,200 L0,200 Z",
    //               "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //             ],
    //           }}
    //           transition={{ duration: 8, repeat: Infinity }}
    //           fill="#105840"
    //           fillOpacity="0.03"
    //         />
    //       </svg>
    //     </div>

    //     <div className="absolute inset-0">
    //       <motion.div
    //         animate={{ rotate: [0, 360] }}
    //         transition={{ duration: 40, repeat: Infinity, ease: "linear" }}
    //         className="absolute -top-40 -right-40 w-96 h-96 border-2 border-[#105840]/10 rounded-full"
    //       />
    //       <motion.div
    //         animate={{ rotate: [360, 0] }}
    //         transition={{ duration: 35, repeat: Infinity, ease: "linear" }}
    //         className="absolute -bottom-40 -left-40 w-[500px] h-[500px] border-2 border-[#105840]/10 rounded-full"
    //       />
    //     </div>

    //     <div className="relative z-10 max-w-7xl mx-auto">
    //       <motion.div
    //         initial={{ opacity: 0, y: 30 }}
    //         whileInView={{ opacity: 1, y: 0 }}
    //         transition={{ duration: 0.6 }}
    //         viewport={{ once: true }}
    //         className="text-center mb-16"
    //       >
    //         <motion.div
    //           className="inline-flex items-center gap-2 px-3 py-1 bg-[#105840]/5 border border-[#105840]/10 rounded-full mb-4"
    //           whileHover={{ scale: 1.05 }}
    //         >
    //           <span className="w-1.5 h-1.5 bg-[#105840] rounded-full animate-pulse" />
    //           <span className="text-xs font-medium text-[#105840]">
    //             OUR PRODUCTS
    //           </span>
    //         </motion.div>

    //         <motion.div
    //           initial={{ width: 0 }}
    //           whileInView={{ width: "80px" }}
    //           transition={{ duration: 0.8 }}
    //           className="h-1 bg-[#105840] mx-auto mb-3"
    //         />

    //         <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
    //           Built for <span style={{ color: "#105840" }}>your needs.</span>
    //         </h2>
    //       </motion.div>

    //       <motion.div
    //         className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"
    //         variants={staggerContainer}
    //         initial="hidden"
    //         whileInView="visible"
    //         viewport={{ once: true, amount: 0.2 }}
    //       >
    //         {[
    //           {
    //             title: "Salary Advance",
    //             desc: "Access up to 75% of earned salary before payday. 0% interest, repaid automatically.",
    //             icon: <FaClock />,
    //             tag: "Popular",
    //             image:
    //               "https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    //             color: "from-[#105840] to-[#0A4A30]",
    //           },
    //           {
    //             title: "Emergency Loan",
    //             desc: "Instant funds for unexpected expenses. Disbursed in under 60 seconds.",
    //             icon: <FaRocket />,
    //             tag: "Fastest",
    //             image:
    //               "https://images.unsplash.com/photo-1615461066841-6116e61058f4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    //             color: "from-[#105840] to-[#0A4A30]",
    //           },
    //           {
    //             title: "Short Term Loan",
    //             desc: "7-30 day loans for bridging gaps. Fixed terms, no surprises.",
    //             icon: <FaChartLine />,
    //             tag: "Flexible",
    //             image:
    //               "https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    //             color: "from-[#105840] to-[#0A4A30]",
    //           },
    //           {
    //             title: "Medical Advance",
    //             desc: "Health emergency funding. Zero questions up to ₹25,000.",
    //             icon: <FaShieldAlt />,
    //             tag: "24/7",
    //             image:
    //               "https://images.unsplash.com/photo-1538108149393-fbbd81895907?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    //             color: "from-[#105840] to-[#0A4A30]",
    //           },
    //           {
    //             title: "Corporate Program",
    //             desc: "Employer-integrated advances. White-label solutions for businesses.",
    //             icon: <FaBuilding />,
    //             tag: "Enterprise",
    //             image:
    //               "https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    //             color: "from-[#105840] to-[#0A4A30]",
    //           },
    //           {
    //             title: "Payday Loan",
    //             desc: "30-day loan product. Auto-debit facility, competitive rates.",
    //             icon: <FaRegGem />,
    //             tag: "New",
    //             image:
    //               "https://images.pexels.com/photos/7688336/pexels-photo-7688336.jpeg?auto=compress&cs=tinysrgb&w=800",
    //             color: "from-[#105840] to-[#0A4A30]",
    //           },
    //         ].map((product, i) => (
    //           <motion.div
    //             key={i}
    //             variants={fadeInUp}
    //             whileHover={{
    //               y: -12,
    //               scale: 1.02,
    //               transition: { type: "spring", stiffness: 400, damping: 15 },
    //             }}
    //             className="group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100"
    //           >
    //             <div className="relative h-48 overflow-hidden">
    //               <motion.img
    //                 src={product.image}
    //                 alt={product.title}
    //                 className="w-full h-full object-cover"
    //                 whileHover={{ scale: 1.1 }}
    //                 transition={{ duration: 0.6 }}
    //                 onError={(e) => {
    //                   e.target.src =
    //                     "https://images.unsplash.com/photo-1565514020179-026b92b5d827?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80";
    //                 }}
    //               />
    //               <div className="absolute inset-0 bg-gradient-to-t from-[#105840]/80 via-transparent to-transparent" />

    //               <motion.div
    //                 initial={{ opacity: 0, y: 20 }}
    //                 whileInView={{ opacity: 1, y: 0 }}
    //                 transition={{ delay: 0.2 }}
    //                 className="absolute top-4 right-4"
    //               >
    //                 <span className="text-xs font-medium text-white bg-[#105840] px-3 py-1 rounded-full shadow-lg">
    //                   {product.tag}
    //                 </span>
    //               </motion.div>

    //               <motion.div
    //                 animate={{ y: [0, -5, 0] }}
    //                 transition={{ duration: 3, repeat: Infinity }}
    //                 className="absolute bottom-4 left-4 w-12 h-12 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center text-white text-2xl border border-white/30"
    //               >
    //                 {product.icon}
    //               </motion.div>
    //             </div>

    //             <div className="p-8">
    //               <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#105840] transition-colors">
    //                 {product.title}
    //               </h3>
    //               <p className="text-gray-600 text-sm leading-relaxed mb-3">
    //                 {product.desc}
    //               </p>

    //               <motion.div
    //                 className="flex items-center justify-between pt-4 border-t border-gray-100"
    //                 whileHover={{ x: 5 }}
    //               >
    //                 <span className="text-sm text-[#105840] font-medium">
    //                   Learn more
    //                 </span>
    //                 <motion.div
    //                   animate={{ x: [0, 8, 0] }}
    //                   transition={{
    //                     duration: 1.5,
    //                     delay: i * 0.1,
    //                     repeat: Infinity,
    //                   }}
    //                   className="text-[#105840]"
    //                 >
    //                   →
    //                 </motion.div>
    //               </motion.div>
    //             </div>

    //             {/* Animated Border */}
    //             <motion.div
    //               className="absolute bottom-0 left-0 h-1 bg-gradient-to-r from-[#105840] to-[#0A4A30]"
    //               initial={{ width: 0 }}
    //               whileInView={{ width: "100%" }}
    //               transition={{ duration: 1, delay: 0.5 }}
    //             />
    //           </motion.div>
    //         ))}
    //       </motion.div>
    //     </div>

    //     {/* Bottom Wave - Increased Height */}
    //     <div className="absolute bottom-0 left-0 w-full pointer-events-none">
    //       <svg
    //         className="w-full h-32 md:h-40"
    //         viewBox="0 0 1440 200"
    //         preserveAspectRatio="none"
    //       >
    //         <motion.path
    //           animate={{
    //             d: [
    //               "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //               "M0,133 C300,100 600,167 900,133 C1200,100 1440,167 1440,133 L1440,200 L0,200 Z",
    //               "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //             ],
    //           }}
    //           transition={{ duration: 8, repeat: Infinity }}
    //           fill="#105840"
    //           fillOpacity="0.03"
    //         />
    //       </svg>
    //     </div>
    //   </section>

    //   {/* Principles Section with Top and Bottom Waves */}
    //   <section className="relative py-28 px-4 sm:px-8 lg:px-12 xl:px-16 overflow-hidden bg-[#F8FAF5]">
    //     {/* Top Wave - Increased Height */}
    //     <div className="absolute top-0 left-0 w-full pointer-events-none rotate-180">
    //       <svg
    //         className="w-full h-32 md:h-40"
    //         viewBox="0 0 1440 200"
    //         preserveAspectRatio="none"
    //       >
    //         <motion.path
    //           animate={{
    //             d: [
    //               "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //               "M0,133 C300,100 600,167 900,133 C1200,100 1440,167 1440,133 L1440,200 L0,200 Z",
    //               "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //             ],
    //           }}
    //           transition={{ duration: 8, repeat: Infinity }}
    //           fill="#105840"
    //           fillOpacity="0.03"
    //         />
    //       </svg>
    //     </div>

    //     <div className="max-w-7xl mx-auto">
    //       <div className="grid lg:grid-cols-2 gap-20 items-center">
    //         <motion.div
    //           initial={{ opacity: 0, x: -50 }}
    //           whileInView={{ opacity: 1, x: 0 }}
    //           transition={{ duration: 0.8 }}
    //           viewport={{ once: true }}
    //         >
    //           <motion.div
    //             className="inline-flex items-center gap-2 px-3 py-1 bg-[#105840]/5 border border-[#105840]/10 rounded-full mb-4"
    //             whileHover={{ scale: 1.05 }}
    //           >
    //             <span className="w-1.5 h-1.5 bg-[#105840] rounded-full animate-pulse" />
    //             <span className="text-xs font-medium text-[#105840]">
    //               OUR PRINCIPLES
    //             </span>
    //           </motion.div>

    //           <motion.div
    //             initial={{ width: 0 }}
    //             whileInView={{ width: "60px" }}
    //             transition={{ duration: 0.8 }}
    //             className="h-1 bg-[#105840] mb-3"
    //           />

    //           <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8 leading-tight">
    //             Four things we
    //             <span className="text-[#105840] block mt-2">
    //               never compromise on.
    //             </span>
    //           </h2>

    //           <div className="space-y-6">
    //             {[
    //               {
    //                 number: "01",
    //                 title: "Transparency",
    //                 desc: "Every fee, every term, every condition — clearly stated. No surprises.",
    //                 icon: "🔍",
    //               },
    //               {
    //                 number: "02",
    //                 title: "Privacy",
    //                 desc: "Your data is yours. We never sell or share without explicit consent.",
    //                 icon: "🔒",
    //               },
    //               {
    //                 number: "03",
    //                 title: "Speed",
    //                 desc: "Decisions in minutes, not days. Time is money, we respect both.",
    //                 icon: "⚡",
    //               },
    //               {
    //                 number: "04",
    //                 title: "Fairness",
    //                 desc: "Equal access, unbiased decisions, ethical practices always.",
    //                 icon: "🤝",
    //               },
    //             ].map((item, i) => (
    //               <motion.div
    //                 key={i}
    //                 initial={{ opacity: 0, x: -30 }}
    //                 whileInView={{ opacity: 1, x: 0 }}
    //                 transition={{ duration: 0.5, delay: i * 0.1 }}
    //                 viewport={{ once: true }}
    //                 whileHover={{ x: 5 }}
    //                 className="flex gap-4 group bg-white p-5 rounded-xl shadow-sm hover:shadow-md transition-all duration-300"
    //               >
    //                 <div className="text-3xl">{item.icon}</div>
    //                 <div>
    //                   <h4 className="text-lg font-bold text-gray-900 mb-1 group-hover:text-[#105840] transition-colors">
    //                     {item.title}
    //                   </h4>
    //                   <p className="text-sm text-gray-600">{item.desc}</p>
    //                 </div>
    //               </motion.div>
    //             ))}
    //           </div>
    //         </motion.div>

    //         <motion.div
    //           initial={{ opacity: 0, x: 50, scale: 0.9 }}
    //           whileInView={{ opacity: 1, x: 0, scale: 1 }}
    //           transition={{ duration: 0.8 }}
    //           viewport={{ once: true }}
    //           className="relative"
    //         >
    //           <div className="relative h-[500px] rounded-2xl overflow-hidden shadow-2xl">
    //             <motion.img
    //               src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
    //               alt="Principles"
    //               className="w-full h-full object-cover"
    //               whileHover={{ scale: 1.1 }}
    //               transition={{ duration: 6 }}
    //             />
    //             <div className="absolute inset-0 bg-gradient-to-t from-[#105840]/60 via-transparent to-transparent" />

    //             <motion.div
    //               animate={{
    //                 y: [0, -10, 0],
    //                 rotate: [0, 2, -2, 0],
    //               }}
    //               transition={{ duration: 5, repeat: Infinity }}
    //               className="absolute bottom-8 left-8 right-8 bg-white/95 backdrop-blur-sm p-6 rounded-xl shadow-2xl border border-white/20"
    //             >
    //               <div className="flex items-center gap-4">
    //                 <motion.div
    //                   whileHover={{ scale: 1.1, rotate: 360 }}
    //                   transition={{ duration: 0.5 }}
    //                   className="w-14 h-14 bg-gradient-to-br from-[#105840] to-[#0A4A30] rounded-xl flex items-center justify-center shadow-lg"
    //                 >
    //                   <FaAward className="text-white text-2xl" />
    //                 </motion.div>
    //                 <div>
    //                   <div className="text-lg font-bold text-gray-900">
    //                     ISO 27001 Certified
    //                   </div>
    //                   <div className="text-sm text-gray-500">
    //                     Bank-grade security, audited annually
    //                   </div>
    //                   <div className="flex gap-1 mt-1">
    //                     {[1, 2, 3, 4, 5].map((star) => (
    //                       <FaStar
    //                         key={star}
    //                         className="text-yellow-400 text-xs"
    //                       />
    //                     ))}
    //                   </div>
    //                 </div>
    //               </div>
    //             </motion.div>

    //             {/* Floating Elements */}
    //             <motion.div
    //               animate={{ rotate: 360 }}
    //               transition={{
    //                 duration: 20,
    //                 repeat: Infinity,
    //                 ease: "linear",
    //               }}
    //               className="absolute top-8 left-8 w-20 h-20 border-2 border-white/30 rounded-full"
    //             />
    //           </div>
    //         </motion.div>
    //       </div>
    //     </div>

    //     {/* Bottom Wave - Increased Height */}
    //     <div className="absolute bottom-0 left-0 w-full pointer-events-none">
    //       <svg
    //         className="w-full h-32 md:h-40"
    //         viewBox="0 0 1440 200"
    //         preserveAspectRatio="none"
    //       >
    //         <motion.path
    //           animate={{
    //             d: [
    //               "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //               "M0,133 C300,100 600,167 900,133 C1200,100 1440,167 1440,133 L1440,200 L0,200 Z",
    //               "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //             ],
    //           }}
    //           transition={{ duration: 8, repeat: Infinity }}
    //           fill="#105840"
    //           fillOpacity="0.03"
    //         />
    //       </svg>
    //     </div>
    //   </section>

    //   {/* Partners Section with Top and Bottom Waves - CONTENT CHANGED */}
    //   {/* <section className="relative py-28 pt-8 px-4 sm:px-8 lg:px-12 xl:px-16 overflow-hidden">
    //     {/* Top Wave - Increased Height
    //     <div className="absolute top-0 left-0 w-full pointer-events-none rotate-180">
    //       <svg
    //         className="w-full h-32 md:h-40"
    //         viewBox="0 0 1440 200"
    //         preserveAspectRatio="none"
    //       >
    //         <motion.path
    //           animate={{
    //             d: [
    //               "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //               "M0,133 C300,100 600,167 900,133 C1200,100 1440,167 1440,133 L1440,200 L0,200 Z",
    //               "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //             ],
    //           }}
    //           transition={{ duration: 8, repeat: Infinity }}
    //           fill="#105840"
    //           fillOpacity="0.03"
    //         />
    //       </svg>
    //     </div>

    //     <div className="absolute inset-0">
    //       <motion.div
    //         animate={{ scale: [1, 1.2, 1], opacity: [0.1, 0.2, 0.1] }}
    //         transition={{ duration: 8, repeat: Infinity }}
    //         className="absolute top-20 right-20 w-96 h-96 bg-[#105840]/5 rounded-full blur-3xl"
    //       />
    //     </div>

    //     {/* <div className="relative z-10 max-w-7xl mx-auto">
    //       <motion.div
    //         initial={{ opacity: 0, y: 30 }}
    //         whileInView={{ opacity: 1, y: 0 }}
    //         transition={{ duration: 0.6 }}
    //         viewport={{ once: true }}
    //         className="text-center mb-16"
    //       >
    //         <motion.div
    //           className="inline-flex items-center gap-2 px-3 py-1 bg-[#105840]/5 border border-[#105840]/10 rounded-full mb-4"
    //           whileHover={{ scale: 1.05 }}
    //         >
    //           <span className="w-1.5 h-1.5 bg-[#105840] rounded-full animate-pulse" />
    //           <span className="text-xs font-medium text-[#105840]">
    //             TRUSTED BY
    //           </span>
    //         </motion.div>

    //         <motion.div
    //           initial={{ width: 0 }}
    //           whileInView={{ width: "80px" }}
    //           transition={{ duration: 0.8 }}
    //           className="h-1 bg-[#105840] mx-auto mb-3"
    //         />

    //         <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
    //           India's Leading
    //           <span style={{ color: "#105840" }}> Financial Institutions</span>
    //         </h2>
    //         <p className="text-lg text-gray-600 mt-4 max-w-2xl mx-auto">
    //           Partnering with the best to serve you better
    //         </p>
    //       </motion.div>

    //       {/* <motion.div
    //         className="grid grid-cols-2 md:grid-cols-4 gap-6"
    //         variants={staggerContainer}
    //         initial="hidden"
    //         whileInView="visible"
    //         viewport={{ once: true, amount: 0.2 }}
    //       >
    //         {[
    //           {
    //             name: "State Bank of India",
    //             type: "Banking Partner",
    //             logo: "🏦",
    //             color: "from-blue-500 to-blue-600",
    //           },
    //           {
    //             name: "HDFC Bank",
    //             type: "Investment Partner",
    //             logo: "📈",
    //             color: "from-purple-500 to-purple-600",
    //           },
    //           {
    //             name: "ICICI Bank",
    //             type: "Audit Partner",
    //             logo: "📊",
    //             color: "from-green-500 to-green-600",
    //           },
    //           {
    //             name: "Axis Bank",
    //             type: "Compliance Partner",
    //             logo: "✓",
    //             color: "from-red-500 to-red-600",
    //           },
    //           {
    //             name: "Kotak Mahindra",
    //             type: "Cloud Partner",
    //             logo: "☁️",
    //             color: "from-orange-500 to-orange-600",
    //           },
    //           {
    //             name: "Yes Bank",
    //             type: "Technology Partner",
    //             logo: "💻",
    //             color: "from-blue-500 to-blue-600",
    //           },
    //           {
    //             name: "Bank of Baroda",
    //             type: "Infrastructure",
    //             logo: "🔍",
    //             color: "from-green-500 to-green-600",
    //           },
    //           {
    //             name: "Canara Bank",
    //             type: "CRM Partner",
    //             logo: "☁️",
    //             color: "from-blue-500 to-blue-600",
    //           },
    //         ].map((partner, i) => (
    //           <motion.div
    //             key={i}
    //             variants={fadeInUp}
    //             whileHover={{
    //               y: -8,
    //               scale: 1.05,
    //               transition: { type: "spring", stiffness: 400 },
    //             }}
    //             className="group relative"
    //           >
    //             <motion.div
    //               className="absolute -inset-2 bg-gradient-to-r opacity-0 group-hover:opacity-100 blur-lg transition-all duration-500"
    //               style={{
    //                 background: `linear-gradient(135deg, ${partner.color})`,
    //               }}
    //             />
    //             <div className="relative bg-white rounded-xl p-6 text-center border border-gray-200 group-hover:border-transparent transition-all duration-500 shadow-md hover:shadow-xl">
    //               <motion.div
    //                 animate={{ scale: [1, 1.1, 1] }}
    //                 transition={{
    //                   duration: 2,
    //                   delay: i * 0.1,
    //                   repeat: Infinity,
    //                 }}
    //                 className="text-4xl mb-3"
    //               >
    //                 {partner.logo}
    //               </motion.div>
    //               <h3 className="font-bold text-gray-900 mb-1">
    //                 {partner.name}
    //               </h3>
    //               <p className="text-xs text-gray-500">{partner.type}</p>

    //               {/* Animated Border
    //               <motion.div
    //                 className="absolute bottom-0 left-1/2 h-0.5 bg-gradient-to-r from-[#105840] to-[#0A4A30]"
    //                 initial={{ width: 0, x: "-50%" }}
    //                 whileHover={{ width: "80%" }}
    //                 transition={{ duration: 0.3 }}
    //               />
    //             </div>
    //           </motion.div>
    //         ))}
    //       </motion.div>
    //     </div> */}

    //     {/* Bottom Wave - Increased Height */}
    //     {/* <div className="absolute bottom-0 left-0 w-full pointer-events-none">
    //       <svg
    //         className="w-full h-32 md:h-40"
    //         viewBox="0 0 1440 200"
    //         preserveAspectRatio="none"
    //       >
    //         <motion.path
    //           animate={{
    //             d: [
    //               "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //               "M0,133 C300,100 600,167 900,133 C1200,100 1440,167 1440,133 L1440,200 L0,200 Z",
    //               "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //             ],
    //           }}
    //           transition={{ duration: 8, repeat: Infinity }}
    //           fill="#105840"
    //           fillOpacity="0.03"
    //         />
    //       </svg>
    //     </div>
    //   </section> */}

    //   {/* Mission & Vision Section with Top and Bottom Waves - Image Changed */}
    //   {/* <section className="relative py-28  pt-8 px-4 sm:px-8 lg:px-12 xl:px-16 bg-gradient-to-br from-[#F8FAF5] to-white">
    //     {/* Top Wave - Increased Height
    //     <div className="absolute top-0 left-0 w-full pointer-events-none rotate-180">
    //       <svg
    //         className="w-full h-32 md:h-40"
    //         viewBox="0 0 1440 200"
    //         preserveAspectRatio="none"
    //       >
    //         <motion.path
    //           animate={{
    //             d: [
    //               "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //               "M0,133 C300,100 600,167 900,133 C1200,100 1440,167 1440,133 L1440,200 L0,200 Z",
    //               "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //             ],
    //           }}
    //           transition={{ duration: 8, repeat: Infinity }}
    //           fill="#105840"
    //           fillOpacity="0.03"
    //         />
    //       </svg>
    //     </div>

    //     <div className="max-w-7xl mx-auto">
    //       {/* Heading for Mission & Vision Section
    //       <div className="text-center mb-10">
    //         <motion.div
    //           className="inline-flex items-center gap-2 px-3 py-1 bg-[#105840]/5 border border-[#105840]/10 rounded-full mb-4"
    //           whileHover={{ scale: 1.05 }}
    //         >
    //           <span className="w-1.5 h-1.5 bg-[#105840] rounded-full animate-pulse" />
    //           <span className="text-xs font-medium text-[#105840]">
    //             OUR PURPOSE
    //           </span>
    //         </motion.div>

    //         <motion.div
    //           initial={{ width: 0 }}
    //           whileInView={{ width: "80px" }}
    //           transition={{ duration: 0.8 }}
    //           className="h-1 bg-[#105840] mx-auto mb-6"
    //         />
    //         <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
    //           Driving Financial
    //           <span style={{ color: "#105840" }}> Inclusion</span>
    //         </h2>
    //         <p className="text-lg text-gray-600 max-w-2xl mx-auto">
    //           What drives us every day to build a better financial future for
    //           India's workforce
    //         </p>
    //       </div>

    //       <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
    //         {[
    //           {
    //             title: "Our Mission",
    //             desc: "To institutionalize short-term credit for India's salaried workforce — making it faster, fairer, and more transparent than traditional banking.",
    //             highlight: "Serve 25M customers by 2028",
    //             icon: "🎯",
    //             image:
    //               "https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    //             gradient: "from-[#105840] to-[#0A4A30]",
    //           },
    //           {
    //             title: "Our Vision",
    //             desc: "To be the most trusted digital lending platform in India, setting new standards for customer protection, data privacy, and responsible lending.",
    //             highlight: "Define the future of salary-linked credit",
    //             icon: "✨",
    //             image:
    //               "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    //             gradient: "from-[#0A4A30] to-[#105840]",
    //           },
    //         ].map((item, i) => (
    //           <motion.div
    //             key={i}
    //             initial={{ opacity: 0, y: 30 }}
    //             whileInView={{ opacity: 1, y: 0 }}
    //             transition={{ duration: 0.6, delay: i * 0.1 }}
    //             viewport={{ once: true }}
    //             whileHover={{ y: -12 }}
    //             className="group relative bg-white rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500"
    //           >
    //             <div
    //               className={`absolute top-0 left-0 w-full h-2 bg-gradient-to-r ${item.gradient}`}
    //             />

    //             <div className="relative h-56 overflow-hidden">
    //               <motion.img
    //                 src={item.image}
    //                 alt={item.title}
    //                 className="w-full h-full object-cover"
    //                 whileHover={{ scale: 1.1 }}
    //                 transition={{ duration: 0.6 }}
    //               />
    //               <div className="absolute inset-0 bg-gradient-to-t from-[#105840]/80 via-transparent to-transparent" />

    //               <motion.div
    //                 animate={{ y: [0, -5, 0] }}
    //                 transition={{ duration: 3, repeat: Infinity }}
    //                 className="absolute bottom-4 left-4 w-16 h-16 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center text-4xl border-2 border-white/30"
    //               >
    //                 {item.icon}
    //               </motion.div>
    //             </div>

    //             <div className="p-8">
    //               <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-[#105840] transition-colors">
    //                 {item.title}
    //               </h3>

    //               <p className="text-gray-600 leading-relaxed mb-6">
    //                 {item.desc}
    //               </p>

    //               <div className="p-5 bg-[#F8FAF5] rounded-xl border-l-4 border-[#105840]">
    //                 <FaQuoteRight className="text-[#105840]/20 text-2xl mb-2" />
    //                 <p className="text-[#105840] font-medium italic">
    //                   {item.highlight}
    //                 </p>
    //               </div>
    //             </div>

    //             {/* Animated Border
    //             <motion.div
    //               className="absolute bottom-0 left-0 h-1 bg-gradient-to-r from-[#105840] to-[#0A4A30]"
    //               initial={{ width: 0 }}
    //               whileInView={{ width: "100%" }}
    //               transition={{ duration: 1, delay: 0.5 }}
    //             />
    //           </motion.div>
    //         ))}
    //       </div>
    //     </div>

    //     {/* Bottom Wave - Increased Height */}
    //     {/* <div className="absolute bottom-0 left-0 w-full pointer-events-none">
    //       <svg
    //         className="w-full h-32 md:h-40"
    //         viewBox="0 0 1440 200"
    //         preserveAspectRatio="none"
    //       >
    //         <motion.path
    //           animate={{
    //             d: [
    //               "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //               "M0,133 C300,100 600,167 900,133 C1200,100 1440,167 1440,133 L1440,200 L0,200 Z",
    //               "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //             ],
    //           }}
    //           transition={{ duration: 8, repeat: Infinity }}
    //           fill="#105840"
    //           fillOpacity="0.03"
    //         />
    //       </svg>
    //     </div>
    //   </section> */}

    //   {/* CTA Section with Top and Bottom Waves - Circles Removed */}
    //   <section className="relative py-25 px-4 sm:px-8 lg:px-12 xl:px-16 overflow-hidden">
    //     {/* Top Wave - Increased Height */}
    //     <div className="absolute top-0 left-0 w-full pointer-events-none rotate-180">
    //       <svg
    //         className="w-full h-32 md:h-40"
    //         viewBox="0 0 1440 200"
    //         preserveAspectRatio="none"
    //       >
    //         <motion.path
    //           animate={{
    //             d: [
    //               "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //               "M0,133 C300,100 600,167 900,133 C1200,100 1440,167 1440,133 L1440,200 L0,200 Z",
    //               "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //             ],
    //           }}
    //           transition={{ duration: 8, repeat: Infinity }}
    //           fill="#105840"
    //           fillOpacity="0.03"
    //         />
    //       </svg>
    //     </div>

    //     <div className="relative z-10 max-w-4xl mx-auto text-center">
    //       <motion.div
    //         initial={{ opacity: 0, y: 30 }}
    //         whileInView={{ opacity: 1, y: 0 }}
    //         transition={{ duration: 0.6 }}
    //         viewport={{ once: true }}
    //       >
    //         <motion.div
    //           className="inline-flex items-center gap-2 px-3 py-1 bg-[#105840]/5 border border-[#105840]/10 rounded-full mb-4"
    //           whileHover={{ scale: 1.05 }}
    //         >
    //           <span className="w-1.5 h-1.5 bg-[#105840] rounded-full animate-pulse" />
    //           <span className="text-xs font-medium text-[#105840]">
    //             GET STARTED
    //           </span>
    //         </motion.div>

    //         <motion.div
    //           initial={{ width: 0 }}
    //           whileInView={{ width: "80px" }}
    //           transition={{ duration: 0.8 }}
    //           className="h-1 bg-[#105840] mx-auto mb-3"
    //         />

    //         <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-3">
    //           Ready for a better way
    //           <span className="text-[#105840] block mt-2">to borrow?</span>
    //         </h2>

    //         <p className="text-xl text-gray-600 mb-10 max-w-2xl mx-auto">
    //           Join 1 million+ professionals who've simplified their financial
    //           life with Salarymates.
    //         </p>

    //         <motion.div
    //           className="flex flex-wrap justify-center gap-4"
    //           variants={staggerContainer}
    //           initial="hidden"
    //           whileInView="visible"
    //         >
    //           <motion.button
    //             variants={fadeInUp}
    //             whileHover={{ scale: 1.05, y: -2 }}
    //             whileTap={{ scale: 0.95 }}
    //             className="group relative px-8 py-4 bg-[#105840] text-white rounded-full font-semibold hover:bg-[#0A4A30] transition-all duration-300 shadow-lg hover:shadow-xl overflow-hidden"
    //           >
    //             <Link
    //               to="/apply-now"
    //               className="relative z-10 flex items-center gap-2"
    //             >
    //               Apply Now
    //               <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
    //             </Link>
    //             <motion.span
    //               className="absolute inset-0 bg-white/20"
    //               initial={{ x: "-100%" }}
    //               whileHover={{ x: "100%" }}
    //               transition={{ duration: 0.5 }}
    //             />
    //           </motion.button>

    //           <motion.button
    //             variants={fadeInUp}
    //             whileHover={{ scale: 1.05, y: -2 }}
    //             whileTap={{ scale: 0.95 }}
    //             className="px-8 py-4 bg-white text-[#105840] rounded-full font-semibold border-2 border-[#105840]/20 hover:border-[#105840]/40 transition-all duration-300 shadow-lg hover:shadow-xl"
    //           >
    //             Talk to Support
    //           </motion.button>
    //         </motion.div>

    //         <motion.div
    //           className="flex items-center justify-center gap-8 mt-12 mb-5 text-sm text-gray-500"
    //           variants={staggerContainer}
    //           initial="hidden"
    //           whileInView="visible"
    //         >
    //           {[
    //             { text: "No hidden fees", icon: <FaCheckCircle /> },
    //             { text: "Instant approval", icon: <FaCheckCircle /> },
    //             { text: "100% secure", icon: <FaCheckCircle /> },
    //           ].map((item, i) => (
    //             <motion.span
    //               key={i}
    //               variants={fadeInUp}
    //               className="flex items-center gap-2"
    //             >
    //               <motion.span
    //                 animate={{ scale: [1, 1.2, 1] }}
    //                 transition={{
    //                   duration: 2,
    //                   delay: i * 0.3,
    //                   repeat: Infinity,
    //                 }}
    //               >
    //                 {item.icon}
    //               </motion.span>
    //               {item.text}
    //             </motion.span>
    //           ))}
    //         </motion.div>
    //       </motion.div>
    //     </div>

    //     {/* Bottom Wave - Increased Height */}
    //     <div className="absolute bottom-0 left-0 w-full pointer-events-none">
    //       <svg
    //         className="w-full h-32 md:h-40"
    //         viewBox="0 0 1440 200"
    //         preserveAspectRatio="none"
    //       >
    //         <motion.path
    //           animate={{
    //             d: [
    //               "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //               "M0,133 C300,100 600,167 900,133 C1200,100 1440,167 1440,133 L1440,200 L0,200 Z",
    //               "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //             ],
    //           }}
    //           transition={{ duration: 8, repeat: Infinity }}
    //           fill="#105840"
    //           fillOpacity="0.03"
    //         />
    //       </svg>
    //     </div>
    //   </section>

    //   {/* Custom Animations */}
    //   <style jsx>{`
    //     @keyframes float {
    //       0%,
    //       100% {
    //         transform: translateY(0);
    //       }
    //       50% {
    //         transform: translateY(-20px);
    //       }
    //     }
    //     @keyframes pulse {
    //       0%,
    //       100% {
    //         opacity: 0.5;
    //         transform: scale(1);
    //       }
    //       50% {
    //         opacity: 0.8;
    //         transform: scale(1.05);
    //       }
    //     }
    //     @keyframes rotate {
    //       from {
    //         transform: rotate(0deg);
    //       }
    //       to {
    //         transform: rotate(360deg);
    //       }
    //     }
    //     .animate-float {
    //       animation: float 6s ease-in-out infinite;
    //     }
    //     .animate-pulse-slow {
    //       animation: pulse 3s ease-in-out infinite;
    //     }
    //   `}</style>
    // </div>
    <div className="bg-[#0A1620] overflow-hidden" ref={containerRef}>
      {/* Hero Section */}
      <section className="relative min-h-[80vh] flex items-center justify-center overflow-hidden px-4 sm:px-8 lg:px-12 xl:px-16">
        {/* Animated Background Elements */}
        <div className="absolute inset-0 pointer-events-none">
          <motion.div
            animate={{
              y: [0, -40, 0],
              x: [0, 30, 0],
              scale: [1, 1.2, 1],
            }}
            transition={{ duration: 20, repeat: Infinity, ease: "easeInOut" }}
            className="absolute top-20 left-[5%] w-72 h-72 bg-[#2D5F7A]/20 rounded-full blur-3xl"
          />
          <motion.div
            animate={{
              y: [0, 40, 0],
              x: [0, -30, 0],
              scale: [1, 1.3, 1],
            }}
            transition={{ duration: 18, repeat: Infinity, ease: "easeInOut" }}
            className="absolute bottom-20 right-[5%] w-96 h-96 bg-[#7BC4E0]/20 rounded-full blur-3xl"
          />
          <motion.div
            animate={{
              scale: [1, 1.4, 1],
              opacity: [0.2, 0.5, 0.2],
              rotate: [0, 180, 360],
            }}
            transition={{ duration: 25, repeat: Infinity, ease: "linear" }}
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#1E3B4A]/30 rounded-full blur-3xl"
          />
        </div>

        {/* Floating Particles */}
        <div className="absolute inset-0 pointer-events-none">
          {[...Array(20)].map((_, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 0 }}
              animate={{
                opacity: [0, 0.8, 0],
                scale: [0, 1.5, 0],
                x: [0, Math.random() * 200 - 100],
                y: [0, Math.random() * 200 - 100],
              }}
              transition={{
                duration: 8 + i,
                repeat: Infinity,
                delay: i * 0.5,
                ease: "easeInOut",
              }}
              className="absolute w-2 h-2 bg-[#7BC4E0] rounded-full"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
              }}
            />
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="relative z-10 max-w-7xl mx-auto text-center"
        >
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ type: "spring", stiffness: 200, delay: 0.2 }}
            className="inline-flex items-center gap-2 px-4 py-2 bg-[#1E3B4A]/30 border border-[#2D5F7A]/30 rounded-full mb-8"
          >
            <motion.span
              animate={{ scale: [1, 1.5, 1] }}
              transition={{ duration: 2, repeat: Infinity }}
              className="w-2 h-2 bg-[#7BC4E0] rounded-full"
            />
            <span className="text-sm font-medium text-[#7BC4E0]">
              SALARYMATES
            </span>
          </motion.div>

          <motion.div
            initial={{ width: 0 }}
            animate={{ width: "80px" }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="h-1 bg-[#7BC4E0] mx-auto mb-6"
          />

          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="text-5xl md:text-7xl font-bold text-white mb-6 tracking-tight"
          >
            We're building the
            <span className="relative ml-3">
              <span className="relative z-10 text-[#7BC4E0]">future</span>
              <motion.span
                initial={{ width: 0 }}
                animate={{ width: "100%" }}
                transition={{ duration: 0.8, delay: 1 }}
                className="absolute -bottom-2 left-0 w-full h-3 bg-[#7BC4E0]/20 rounded-full"
              />
            </span>
            <br />
            of salary lending.
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="text-xl text-[#CCE6F5] max-w-3xl mx-auto leading-relaxed"
          >
            A new standard for short-term credit — transparent, fair, and built
            for the way you work today.
          </motion.p>
        </motion.div>
      </section>

      {/* Founded Section with Animations */}
      <section className="relative py-10 pt-5 px-4 sm:px-8 lg:px-12 xl:px-16">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center"
          >
            <motion.div
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              transition={{ type: "spring", stiffness: 200 }}
              viewport={{ once: true }}
              className="inline-flex items-center gap-2 px-3 py-1 bg-[#1E3B4A]/30 border border-[#2D5F7A]/30 rounded-full mb-4"
            >
              <motion.span
                animate={{ scale: [1, 1.5, 1] }}
                transition={{ duration: 2, repeat: Infinity }}
                className="w-1.5 h-1.5 bg-[#7BC4E0] rounded-full"
              />
              <span className="text-xs font-medium text-[#7BC4E0]">
                OUR JOURNEY
              </span>
            </motion.div>

            <motion.div
              initial={{ width: 0 }}
              whileInView={{ width: "60px" }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="h-1 bg-[#7BC4E0] mx-auto mb-6"
            />

            <motion.div
              variants={{
                hidden: { opacity: 0 },
                visible: { opacity: 1, transition: { staggerChildren: 0.2 } },
              }}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              className="grid md:grid-cols-3 gap-8 mt-12"
            >
              {[
                {
                  icon: <FaRocket className="text-3xl text-white" />,
                  title: "Our Mission",
                  desc: "Started with a vision to simplify salary-based financial support for working professionals",
                },
                {
                  icon: <FaUsers className="text-3xl text-white" />,
                  title: "50+ Team Members",
                  desc: "Dedicated professionals working to make your financial journey seamless",
                },
                {
                  icon: <FaRegGem className="text-3xl text-white" />,
                  title: "1M+ Customers",
                  desc: "Trusted by over a million salaried individuals across India",
                },
              ].map((item, i) => (
                <motion.div
                  key={i}
                  variants={{
                    hidden: { opacity: 0, y: 30 },
                    visible: { opacity: 1, y: 0 },
                  }}
                  whileHover={{ y: -10, scale: 1.02 }}
                  transition={{ type: "spring", stiffness: 400 }}
                  className="bg-[#1A2F3A] rounded-2xl p-8 shadow-lg border border-[#2D5F7A]/30 relative overflow-hidden group"
                >
                  <motion.div
                    animate={{ rotate: 360 }}
                    transition={{
                      duration: 20,
                      repeat: Infinity,
                      ease: "linear",
                    }}
                    className="absolute -top-10 -right-10 w-20 h-20 bg-[#2D5F7A]/10 rounded-full"
                  />

                  <motion.div
                    whileHover={{ scale: 1.1, rotate: 5 }}
                    className="w-16 h-16 bg-[#2D5F7A] rounded-xl flex items-center justify-center mb-6 mx-auto"
                  >
                    {item.icon}
                  </motion.div>
                  <h3 className="text-xl font-bold text-white mb-3 group-hover:text-[#7BC4E0] transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-[#8FAFC7]">{item.desc}</p>
                </motion.div>
              ))}
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Philosophy Section with Image Animation */}
      <section className="relative py-28 pt-5 px-4 sm:px-8 lg:px-12 xl:px-16 overflow-hidden bg-[#0F2128]">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-20 items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <motion.div
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                transition={{ type: "spring", stiffness: 200 }}
                viewport={{ once: true }}
                className="inline-flex items-center gap-2 px-3 py-1 bg-[#1E3B4A]/30 border border-[#2D5F7A]/30 rounded-full mb-4"
              >
                <motion.span
                  animate={{ scale: [1, 1.5, 1] }}
                  transition={{ duration: 2, repeat: Infinity }}
                  className="w-1.5 h-1.5 bg-[#7BC4E0] rounded-full"
                />
                <span className="text-xs font-medium text-[#7BC4E0]">
                  OUR PHILOSOPHY
                </span>
              </motion.div>

              <motion.div
                initial={{ width: 0 }}
                whileInView={{ width: "60px" }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
                className="h-1 bg-[#7BC4E0] mb-3"
              />

              <h2 className="text-4xl md:text-5xl font-bold text-white mb-2 leading-tight">
                Lending,
                <span className="text-[#7BC4E0] block mt-2">
                  reimagined for you.
                </span>
              </h2>

              <p className="text-lg text-[#CCE6F5] leading-relaxed mb-8">
                We believe financial products should be simple. No fine print,
                no hidden fees, no complicated terms. Just fair, transparent
                access to credit when you need it.
              </p>

              <div className="space-y-4">
                {[
                  "No hidden charges — ever",
                  "Clear terms, simple language",
                  "Decisions in minutes, not days",
                  "24/7 customer support",
                ].map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ delay: i * 0.1 }}
                    viewport={{ once: true }}
                    whileHover={{ x: 5 }}
                    className="flex items-center gap-3 group"
                  >
                    <motion.div
                      whileHover={{ scale: 1.2, backgroundColor: "#7BC4E0" }}
                      className="w-6 h-6 bg-[#2D5F7A]/30 rounded-full flex items-center justify-center"
                    >
                      <span className="text-[#7BC4E0] group-hover:text-white transition-colors">
                        ✓
                      </span>
                    </motion.div>
                    <span className="text-[#CCE6F5]">{item}</span>
                  </motion.div>
                ))}
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="relative"
            >
              <div className="relative h-[500px] rounded-2xl overflow-hidden shadow-2xl group">
                <motion.img
                  src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
                  alt="Team Collaboration"
                  className="w-full h-full object-cover"
                  whileHover={{ scale: 1.1 }}
                  transition={{ duration: 6 }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1E3B4A]/80 via-transparent to-transparent" />

                <motion.div
                  animate={{ y: [0, -10, 0] }}
                  transition={{ duration: 4, repeat: Infinity }}
                  className="absolute bottom-8 left-8 right-8 bg-[#1A2F3A]/95 backdrop-blur-sm p-6 rounded-xl shadow-2xl border border-[#2D5F7A]/30"
                >
                  <div className="flex items-center gap-4">
                    <motion.div
                      whileHover={{ scale: 1.1, rotate: 360 }}
                      transition={{ duration: 0.5 }}
                      className="w-14 h-14 bg-gradient-to-br from-[#2D5F7A] to-[#1E3B4A] rounded-xl flex items-center justify-center shadow-lg"
                    >
                      <FaUsers className="text-white text-2xl" />
                    </motion.div>
                    <div>
                      <div className="text-lg font-bold text-white">
                        50+ Team Members
                      </div>
                      <div className="text-sm text-[#8FAFC7]">
                        Dedicated to your success
                      </div>
                      <div className="flex gap-2 mt-2">
                        <FaLinkedin className="text-[#8FAFC7] hover:text-[#7BC4E0] cursor-pointer transition-colors" />
                        <FaTwitter className="text-[#8FAFC7] hover:text-[#7BC4E0] cursor-pointer transition-colors" />
                        <FaEnvelope className="text-[#8FAFC7] hover:text-[#7BC4E0] cursor-pointer transition-colors" />
                      </div>
                    </div>
                  </div>
                </motion.div>

                <motion.div
                  animate={{ y: [0, -5, 0], x: [0, 5, 0] }}
                  transition={{ duration: 3, repeat: Infinity }}
                  className="absolute top-8 right-8 bg-[#1A2F3A]/90 backdrop-blur-sm px-4 py-2 rounded-full shadow-lg border border-[#2D5F7A]/30"
                >
                  <span className="text-sm font-semibold text-[#7BC4E0]">
                    ✨ Trusted Service
                  </span>
                </motion.div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      {/* Situations Where SalaryMates Can Help - Auto Horizontal Slider */}
      <section className="relative py-20 px-4 sm:px-8 lg:px-12 xl:px-16 overflow-hidden">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <motion.div
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              transition={{ type: "spring", stiffness: 200 }}
              viewport={{ once: true }}
              className="inline-flex items-center gap-2 px-3 py-1 bg-[#1E3B4A]/30 border border-[#2D5F7A]/30 rounded-full mb-4"
            >
              <motion.span
                animate={{ scale: [1, 1.5, 1] }}
                transition={{ duration: 2, repeat: Infinity }}
                className="w-1.5 h-1.5 bg-[#7BC4E0] rounded-full"
              />
              <span className="text-xs font-medium text-[#7BC4E0]">
                WHEN TO REACH US
              </span>
            </motion.div>

            <motion.div
              initial={{ width: 0 }}
              whileInView={{ width: "80px" }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="h-1 bg-[#7BC4E0] mx-auto mb-6"
            />

            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Situations Where{" "}
              <span className="text-[#7BC4E0]">SalaryMates</span> Can Help
            </h2>
            <p className="text-lg text-[#8FAFC7] max-w-2xl mx-auto">
              You can reach out to us when you're facing real-life financial
              situations like:
            </p>
          </motion.div>

          {/* Auto-scrolling slider container */}
          <div className="relative">
            {/* Auto-scrolling wrapper */}
            <div className="flex overflow-hidden">
              <motion.div
                className="flex gap-6"
                animate={{
                  x: [0, -2000],
                }}
                transition={{
                  duration: 30,
                  repeat: Infinity,
                  ease: "linear",
                  repeatType: "loop",
                }}
              >
                {/* First set of cards */}
                {[
                  {
                    icon: "🏥",
                    title: "Medical Expenses",
                    desc: "Unexpected health-related costs or urgent treatments",
                  },
                  {
                    icon: "✈️",
                    title: "Travel Needs",
                    desc: "Emergency travel or important personal trips",
                  },
                  {
                    icon: "📚",
                    title: "Education Expenses",
                    desc: "Course fees, certifications, or skill development",
                  },
                  {
                    icon: "🏠",
                    title: "Household Emergencies",
                    desc: "Sudden repairs, maintenance, or essential home needs",
                  },
                  {
                    icon: "💰",
                    title: "Monthly Cash Flow Gaps",
                    desc: "Managing expenses before your next salary cycle",
                  },
                  {
                    icon: "👪",
                    title: "Family Commitments",
                    desc: "Functions, responsibilities, or urgent family needs",
                  },
                  {
                    icon: "📄",
                    title: "Bill Payments",
                    desc: "Rent, utilities, or other important dues",
                  },
                  {
                    icon: "⚡",
                    title: "Personal Emergencies",
                    desc: "Any urgent situation requiring immediate financial attention",
                  },
                  // Duplicate for seamless loop
                  {
                    icon: "🏥",
                    title: "Medical Expenses",
                    desc: "Unexpected health-related costs or urgent treatments",
                  },
                  {
                    icon: "✈️",
                    title: "Travel Needs",
                    desc: "Emergency travel or important personal trips",
                  },
                  {
                    icon: "📚",
                    title: "Education Expenses",
                    desc: "Course fees, certifications, or skill development",
                  },
                  {
                    icon: "🏠",
                    title: "Household Emergencies",
                    desc: "Sudden repairs, maintenance, or essential home needs",
                  },
                ].map((item, i) => (
                  <motion.div
                    key={i}
                    whileHover={{
                      y: -10,
                      scale: 1.02,
                      boxShadow: "0 20px 40px rgba(0,0,0,0.3)",
                      transition: { type: "spring", stiffness: 400 },
                    }}
                    className="group bg-[#1A2F3A] rounded-xl p-6 shadow-lg border border-[#2D5F7A]/30 relative overflow-hidden min-w-[280px] md:min-w-[300px] flex-shrink-0"
                  >
                    {/* Animated background on hover */}
                    <motion.div
                      initial={{ scale: 0, opacity: 0 }}
                      whileHover={{ scale: 1, opacity: 1 }}
                      transition={{ duration: 0.3 }}
                      className="absolute inset-0 bg-gradient-to-br from-[#2D5F7A]/20 to-[#7BC4E0]/20"
                    />

                    <motion.div
                      whileHover={{ rotate: 360 }}
                      transition={{ duration: 0.6 }}
                      className="w-14 h-14 bg-[#0F2128] rounded-xl flex items-center justify-center mb-4 text-3xl border border-[#2D5F7A]/30 relative z-10"
                    >
                      {item.icon}
                    </motion.div>

                    <h3 className="text-lg font-bold text-white mb-2 group-hover:text-[#7BC4E0] transition-colors relative z-10">
                      {item.title}
                    </h3>
                    <p className="text-sm text-[#8FAFC7] leading-relaxed relative z-10">
                      {item.desc}
                    </p>

                    {/* Animated border */}
                    <motion.div
                      initial={{ width: 0 }}
                      whileHover={{ width: "100%" }}
                      transition={{ duration: 0.3 }}
                      className="absolute bottom-0 left-0 h-1 bg-gradient-to-r from-[#2D5F7A] to-[#7BC4E0]"
                    />
                  </motion.div>
                ))}
              </motion.div>
            </div>

            {/* Gradient fade on edges */}
            <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-[#0A1620] to-transparent pointer-events-none z-10" />
            <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-[#0A1620] to-transparent pointer-events-none z-10" />
          </div>

          {/* Pause on hover instruction - optional */}
          {/* <p className="text-center text-[#8FAFC7] text-sm mt-4">
      Hover over cards to pause animation
    </p> */}
        </div>
      </section>
      {/* Stats Section with Animated Counters */}
      <section className="relative py-28 px-4 sm:px-8 lg:px-12 xl:px-16">
        <div className="max-w-7xl mx-auto">
          <motion.div
            variants={{
              hidden: { opacity: 0 },
              visible: { opacity: 1, transition: { staggerChildren: 0.2 } },
            }}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-12"
          >
            {[
              {
                value: "100%",
                label: "Digital process",
                icon: "💰",
              },
              {
                value: "10L+",
                label: "Happy Borrowers",
                icon: "👥",
              },
              {
                value: "4.2min",
                label: "Avg. Approval",
                icon: "⚡",
              },
              {
                value: "50+",
                label: "Banking Partners",
                icon: "🤝",
              },
            ].map((stat, i) => (
              <motion.div
                key={i}
                variants={{
                  hidden: { opacity: 0, scale: 0.8 },
                  visible: { opacity: 1, scale: 1 },
                }}
                whileHover={{ y: -8, scale: 1.05 }}
                transition={{ type: "spring", stiffness: 400 }}
                className="relative group bg-[#1A2F3A] rounded-2xl p-6 shadow-lg border border-[#2D5F7A]/30 overflow-hidden"
              >
                <motion.div
                  animate={{ rotate: [0, 360] }}
                  transition={{
                    duration: 20,
                    repeat: Infinity,
                    ease: "linear",
                  }}
                  className="absolute -top-10 -right-10 w-40 h-40 bg-[#2D5F7A]/10 rounded-full"
                />

                <motion.div
                  animate={{ scale: [1, 1.2, 1] }}
                  transition={{ duration: 2, delay: i * 0.3, repeat: Infinity }}
                  className="text-5xl mb-4 relative z-10"
                >
                  {stat.icon}
                </motion.div>

                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.2 + i * 0.1 }}
                  className="text-3xl md:text-4xl font-bold text-[#7BC4E0] mb-2 relative z-10"
                >
                  {stat.value}
                </motion.div>

                <div className="text-sm text-[#8FAFC7] relative z-10">
                  {stat.label}
                </div>

                {/* Animated Progress Bar */}
                <motion.div
                  initial={{ width: 0 }}
                  whileInView={{ width: "100%" }}
                  transition={{ duration: 1, delay: 0.5 + i * 0.1 }}
                  className="absolute bottom-0 left-0 h-1 bg-gradient-to-r from-[#2D5F7A] to-[#7BC4E0] rounded-b-2xl"
                />
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Principles Section */}
      <section className="relative py-8 px-4 sm:px-8 lg:px-12 xl:px-16 overflow-hidden bg-[#0F2128]">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-20 items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <motion.div
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                transition={{ type: "spring", stiffness: 200 }}
                viewport={{ once: true }}
                className="inline-flex items-center gap-2 px-3 py-1 bg-[#1E3B4A]/30 border border-[#2D5F7A]/30 rounded-full mb-4"
              >
                <motion.span
                  animate={{ scale: [1, 1.5, 1] }}
                  transition={{ duration: 2, repeat: Infinity }}
                  className="w-1.5 h-1.5 bg-[#7BC4E0] rounded-full"
                />
                <span className="text-xs font-medium text-[#7BC4E0]">
                  OUR PRINCIPLES
                </span>
              </motion.div>

              <motion.div
                initial={{ width: 0 }}
                whileInView={{ width: "60px" }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
                className="h-1 bg-[#7BC4E0] mb-3"
              />

              <h2 className="text-4xl md:text-5xl font-bold text-white mb-8 leading-tight">
                Three things we
                <span className="text-[#7BC4E0] block mt-2">
                  never compromise on.
                </span>
              </h2>

              <div className="space-y-6">
                {[
                  {
                    number: "01",
                    title: "Transparency",
                    desc: "Every fee, every term, every condition — clearly stated. No surprises.",
                    icon: "🔍",
                  },
                  {
                    number: "02",
                    title: "Privacy",
                    desc: "Your data is yours. We never sell or share without explicit consent.",
                    icon: "🔒",
                  },

                  {
                    number: "03",
                    title: "Fairness",
                    desc: "Equal access, unbiased decisions, ethical practices always.",
                    icon: "🤝",
                  },
                ].map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ delay: i * 0.1 }}
                    viewport={{ once: true }}
                    whileHover={{ x: 5 }}
                    className="flex gap-4 group bg-[#1A2F3A] p-5 rounded-xl shadow-sm border border-[#2D5F7A]/30"
                  >
                    <motion.div
                      whileHover={{ scale: 1.2, rotate: 10 }}
                      className="text-3xl"
                    >
                      {item.icon}
                    </motion.div>
                    <div>
                      <h4 className="text-lg font-bold text-white mb-1 group-hover:text-[#7BC4E0] transition-colors">
                        {item.title}
                      </h4>
                      <p className="text-sm text-[#8FAFC7]">{item.desc}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="relative"
            >
              <div className="relative h-[500px] rounded-2xl overflow-hidden shadow-2xl group">
                <motion.img
                  src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
                  alt="Principles"
                  className="w-full h-full object-cover"
                  whileHover={{ scale: 1.1 }}
                  transition={{ duration: 6 }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1E3B4A]/80 via-transparent to-transparent" />

                <motion.div
                  animate={{ y: [0, -10, 0] }}
                  transition={{ duration: 4, repeat: Infinity }}
                  className="absolute bottom-8 left-8 right-8 bg-[#1A2F3A]/95 backdrop-blur-sm p-6 rounded-xl shadow-2xl border border-[#2D5F7A]/30"
                >
                  <div className="flex items-center gap-4">
                    <motion.div
                      whileHover={{ scale: 1.1, rotate: 360 }}
                      transition={{ duration: 0.5 }}
                      className="w-14 h-14 bg-gradient-to-br from-[#2D5F7A] to-[#1E3B4A] rounded-xl flex items-center justify-center shadow-lg"
                    >
                      <FaAward className="text-white text-2xl" />
                    </motion.div>
                    <div>
                      <div className="text-lg font-bold text-white">
                        Anytime Solution for Salaried Professionals
                      </div>
                    </div>
                  </div>
                </motion.div>

                <motion.div
                  animate={{ rotate: 360 }}
                  transition={{
                    duration: 20,
                    repeat: Infinity,
                    ease: "linear",
                  }}
                  className="absolute top-8 left-8 w-20 h-20 border-2 border-white/30 rounded-full"
                />
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative py-25 pt-10 px-4 sm:px-8 lg:px-12 xl:px-16 overflow-hidden">
        <div className="relative z-10 max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <motion.div
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              transition={{ type: "spring", stiffness: 200 }}
              viewport={{ once: true }}
              className="inline-flex items-center gap-2 px-3 py-1 bg-[#1E3B4A]/30 border border-[#2D5F7A]/30 rounded-full mb-4"
            >
              <motion.span
                animate={{ scale: [1, 1.5, 1] }}
                transition={{ duration: 2, repeat: Infinity }}
                className="w-1.5 h-1.5 bg-[#7BC4E0] rounded-full"
              />
              <span className="text-xs font-medium text-[#7BC4E0]">
                GET STARTED
              </span>
            </motion.div>

            <motion.div
              initial={{ width: 0 }}
              whileInView={{ width: "80px" }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="h-1 bg-[#7BC4E0] mx-auto mb-3"
            />

            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-3">
              Ready for a better way
              <span className="text-[#7BC4E0] block mt-2">to borrow?</span>
            </h2>

            <p className="text-xl text-[#CCE6F5] mb-10 max-w-2xl mx-auto">
              Join 1 million+ professionals who've simplified their financial
              life with Salarymates.
            </p>

            <motion.div
              variants={{
                hidden: { opacity: 0 },
                visible: { opacity: 1, transition: { staggerChildren: 0.2 } },
              }}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              className="flex flex-wrap justify-center gap-4"
            >
              <motion.button
                variants={{
                  hidden: { opacity: 0, y: 20 },
                  visible: { opacity: 1, y: 0 },
                }}
                whileHover={{ scale: 1.05, y: -2 }}
                whileTap={{ scale: 0.95 }}
                className="group relative px-8 py-4 bg-[#2D5F7A] text-white rounded-full font-semibold hover:bg-[#1E3B4A] transition-all duration-300 shadow-lg hover:shadow-xl overflow-hidden"
              >
                <Link
                  to="/apply-now"
                  className="relative z-10 flex items-center gap-2"
                >
                  Apply Now
                  <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
                </Link>
                <motion.span
                  className="absolute inset-0 bg-white/20"
                  initial={{ x: "-100%" }}
                  whileHover={{ x: "100%" }}
                  transition={{ duration: 0.5 }}
                />
              </motion.button>

              <motion.button
                variants={{
                  hidden: { opacity: 0, y: 20 },
                  visible: { opacity: 1, y: 0 },
                }}
                whileHover={{ scale: 1.05, y: -2 }}
                whileTap={{ scale: 0.95 }}
                className="px-8 py-4 bg-transparent text-[#7BC4E0] rounded-full font-semibold border-2 border-[#2D5F7A]/30 hover:border-[#7BC4E0]/40 transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                Talk to Support
              </motion.button>
            </motion.div>

            <motion.div
              variants={{
                hidden: { opacity: 0 },
                visible: { opacity: 1, transition: { staggerChildren: 0.1 } },
              }}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              className="flex items-center justify-center gap-8 mt-12 mb-5 text-sm text-[#8FAFC7]"
            >
              {[
                { text: "No hidden fees", icon: <FaCheckCircle /> },
                { text: "Instant approval", icon: <FaCheckCircle /> },
                { text: "100% secure", icon: <FaCheckCircle /> },
              ].map((item, i) => (
                <motion.span
                  key={i}
                  variants={{
                    hidden: { opacity: 0, y: 10 },
                    visible: { opacity: 1, y: 0 },
                  }}
                  whileHover={{ scale: 1.05, color: "#7BC4E0" }}
                  className="flex items-center gap-2 cursor-default"
                >
                  <motion.span
                    animate={{ scale: [1, 1.2, 1] }}
                    transition={{
                      duration: 2,
                      delay: i * 0.3,
                      repeat: Infinity,
                    }}
                    className="text-[#7BC4E0]"
                  >
                    {item.icon}
                  </motion.span>
                  {item.text}
                </motion.span>
              ))}
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Custom Styles */}
      <style jsx>{`
        @keyframes float {
          0%,
          100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-20px);
          }
        }
        @keyframes pulse {
          0%,
          100% {
            opacity: 0.5;
            transform: scale(1);
          }
          50% {
            opacity: 0.8;
            transform: scale(1.05);
          }
        }
        @keyframes rotate {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
        .animate-pulse-slow {
          animation: pulse 3s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default About;
